// src/generated.ts
import { z as z2 } from "zod";
import { AccuracyOfDataConsentSchema, AgentRegistrationSchema, ApplicantDetailsSchema, ApplicantDocUploadRequestSchema, ApplicantEmploymentSchema, ApplicantIdentitySchema, ApplicantReferralSchema, ApplicantRegistrationSchema, ContactDetailsSchema, ContactInformationSchema, CreateApplicantOfferRequirementTasksSchema, DeclarationsSchema, DiversitySchema, DocumentFulfilmentSchema, DocumentSchema, EnglishResultsFulfilmentSchema, EnglishSchema, ExemptApplicantOfferRequirementSchema, FeeStatusSchema, InformationProcessingConsentSchema, InternalDocumentSchema, NationalitySchema, OfferPassportSchema, OtherNamePayloadSchema, PersonalStatementSchema, PrivacyPolicyConsentSchema, ProgrammeChoicesSchema, ProofOfPaymentSchema, ProviderRegistrationSchema, QualificationSchema, RefereeDetailsFulfilmentSchema, ReferencesSchema, ReinstateApplicantOfferSchema, RepresentationFormSchema, ResearchProposalSchema, StaffCreateApplicantOfferSchema, StudentAuthoriseAgentSchema, StudySchema, TermsAndConditionsConsentSchema, UniStaffRegistrationSchema, UpdateApplicantOfferLetterTextSchema, UpdateApplicantOfferPayment, UpdateApplicantOfferProgrammeDetailsSchema, UpdateApplicantOfferRequirementTaskLevelSchema, UpdateApplicantOfferRequirementTaskStatusSchema, UpdateApplicantOfferStatusActionSchema, UpdateApplicantOfferStatusSchema } from "types";

// src/schemas.ts
import { z } from "zod";
var ApplyConfigSchema = z.object({
  applyEnabled: z.boolean(),
  applyStudentNoEnabled: z.boolean(),
  partialApplyJourney: z.boolean(),
  additionalProgrammeEnabled: z.boolean().optional(),
  genderEnabled: z.boolean().optional(),
  applyExternalCourseIdPattern: z.string().optional(),
  importToCasShieldDropdown: z.string().optional(),
  termsAndConditionsUrl: z.string().url("Please enter a valid URL").min(1, "Terms and Conditions URL is required").optional(),
  privacyPolicyUrl: z.string().url("Please enter a valid URL").min(1, "Privacy Policy URL is required").optional(),
  customSubdomain: z.string().optional(),
  sslCertificateArn: z.string().optional(),
  createDefaultConfig: z.boolean().optional(),
  createSampleCourses: z.boolean().optional(),
  offerLetterConfig: z.array(
    z.object({
      type: z.string(),
      id: z.string()
    })
  ).optional(),
  addressLookupEnabled: z.boolean().optional()
});

// src/generated.ts
var Schemas = {
  AccuracyOfDataConsentSchema,
  AgentRegistrationSchema,
  ApplicantDetailsSchema,
  ApplicantDocUploadRequestSchema,
  ApplicantEmploymentSchema,
  ApplicantIdentitySchema,
  ApplicantReferralSchema,
  ApplicantRegistrationSchema,
  ApplyConfigSchema,
  ContactDetailsSchema,
  ContactInformationSchema,
  CreateApplicantOfferRequirementTasksSchema,
  DeclarationsSchema,
  DiversitySchema,
  DocumentFulfilmentSchema,
  DocumentSchema,
  EnglishResultsFulfilmentSchema,
  EnglishSchema,
  ExemptApplicantOfferRequirementSchema,
  FeeStatusSchema,
  InformationProcessingConsentSchema,
  InternalDocumentSchema,
  NationalitySchema,
  OfferPassportSchema,
  OtherNamePayloadSchema,
  PersonalStatementSchema,
  PrivacyPolicyConsentSchema,
  ProgrammeChoicesSchema,
  ProofOfPaymentSchema,
  ProviderRegistrationSchema,
  QualificationSchema,
  RefereeDetailsFulfilmentSchema,
  ReferencesSchema,
  ReinstateApplicantOfferSchema,
  RepresentationFormSchema,
  ResearchProposalSchema,
  StaffCreateApplicantOfferSchema,
  StudentAuthoriseAgentSchema,
  StudySchema,
  TermsAndConditionsConsentSchema,
  UniStaffRegistrationSchema,
  UpdateApplicantOfferLetterTextSchema,
  UpdateApplicantOfferPayment,
  UpdateApplicantOfferProgrammeDetailsSchema,
  UpdateApplicantOfferRequirementTaskLevelSchema,
  UpdateApplicantOfferRequirementTaskStatusSchema,
  UpdateApplicantOfferStatusActionSchema,
  UpdateApplicantOfferStatusSchema
};
var ApiValidationError = class extends Error {
  constructor(message, fields, details) {
    super(message);
    this.fields = fields;
    this.details = details;
    this.name = "ApiValidationError";
    Object.defineProperty(this, "stack", {
      get: () => `${this.name}: ${this.message}`,
      configurable: true
    });
  }
  // Override toString to show only the message without stack
  toString() {
    return `${this.name}: ${this.message}`;
  }
  // Provide clean JSON serialization
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      fields: this.fields,
      details: this.details
    };
  }
};
function formatZodError(error, context) {
  const formattedErrors = error.format();
  const fields = {};
  const details = [];
  for (const [field, fieldError] of Object.entries(formattedErrors)) {
    if (field !== "_errors" && typeof fieldError === "object" && fieldError !== null && "_errors" in fieldError) {
      const errors = fieldError._errors;
      fields[field] = errors;
      errors.forEach((msg) => {
        details.push(`${field}: ${msg}`);
      });
    }
  }
  if (formattedErrors._errors && formattedErrors._errors.length > 0) {
    formattedErrors._errors.forEach((msg) => {
      details.push(msg);
    });
  }
  const fieldCount = Object.keys(fields).length;
  const missingOrInvalidFields = Object.keys(fields).join(", ");
  let message = `Validation failed for ${context}.`;
  if (fieldCount > 0) {
    message += ` The following field${fieldCount > 1 ? "s are" : " is"} missing or invalid: ${missingOrInvalidFields}`;
  }
  return { message, fields, details };
}
var globalFetchConfig;
function configureFetch(config) {
  globalFetchConfig = config;
}
function makeRequest(method, url, body, options) {
  if (!globalFetchConfig) {
    throw new Error("API client not configured. Call configureFetch() before making requests.");
  }
  const fullUrl = globalFetchConfig.baseUrl ? globalFetchConfig.baseUrl + url : url;
  return globalFetchConfig.fetch(method, fullUrl, body, options);
}
function buildQueryString(params) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === void 0 || value === null) continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      for (const item of value) {
        if (item !== void 0 && item !== null) {
          searchParams.append(key, String(item));
        }
      }
    } else {
      searchParams.append(key, String(value));
    }
  }
  return searchParams.toString();
}
var ApiClient = {
  UpdateMessages: {
    /**
     * POST /messages
     * @returns Promise<ApiResponse<IMessage>>
     */
    messages: (() => {
      const method = "POST";
      const path = "/messages";
      const buildUrl = () => "/messages";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  Student: {
    Messages: {
      /**
       * POST /messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<IMessage>>
       */
      send: (() => {
        const method = "POST";
        const path = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      read: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      unread: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    RecordedInterview: {
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<{ [key: string]: Omit<IRecordedInterviewEntry, 'questions' | 'hasMismatchedQuestions'> } | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews-check
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      check: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews-check";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews-check";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      regenerateScores: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), interviewId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<RecordedInterviewResponse>>
       */
      questions: (() => {
        const method = "GET";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), interviewId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId ?? validated.INTERVIEWID ?? validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      editScores: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), interviewId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      assessment: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), interviewId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}
       * @pathParams {uni: string, studentNo: string, interviewId: string, videoId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      processing: (() => {
        const method = "GET";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), interviewId: z2.string(), videoId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            url = url.replace("{videoId}", encodeURIComponent(String(validated.videoId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Offer: {
      DownloadAll: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/download
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @body z.object({ includeHidden: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const bodySchema = z2.object({ includeHidden: z2.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * GET /student/{uni}/{studentNo}/{intakeId}/{offerId}/download
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Finance: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/finance
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      VisaPrep: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      FinanceDocument: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        noDoc: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        replaced: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        updateStatus: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        requestCustom: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      FollowUpDocument: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        updateStatus: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        requestCustom: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Risks: {
        /**
         * PUT /student/{uni}/{studentNo}/{intakeId}/{offerId}/risks
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        put: (() => {
          const method = "PUT";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CalendlyInterview: {
        Doc: {
          /**
           * DELETE /student/{uni}/{studentNo}/scheduled-interview/doc
           * @pathParams {uni: string, studentNo: string}
           * @body z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })])
           * @returns Promise<ApiResponse<APIResponse>>
           */
          delete: (() => {
            const method = "DELETE";
            const path = "/student/{uni}/{studentNo}/scheduled-interview/doc";
            const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
            const bodySchema = z2.union([z2.object({ eventName: z2.string(), interviewType: z2.string(), eventType: z2.string(), eventKey: z2.string(), fileNames: z2.array(z2.string()) }), z2.object({ interviewType: z2.string(), eventType: z2.string(), eventKey: z2.string(), deletedFileName: z2.string(), uploadedBy: z2.string() })]);
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/student/{uni}/{studentNo}/scheduled-interview/doc";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })(),
          /**
           * POST /student/{uni}/{studentNo}/scheduled-interview/doc
           * @pathParams {uni: string, studentNo: string}
           * @body z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })])
           * @returns Promise<ApiResponse<APIResponse>>
           */
          post: (() => {
            const method = "POST";
            const path = "/student/{uni}/{studentNo}/scheduled-interview/doc";
            const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
            const bodySchema = z2.union([z2.object({ eventName: z2.string(), interviewType: z2.string(), eventType: z2.string(), eventKey: z2.string(), fileNames: z2.array(z2.string()) }), z2.object({ interviewType: z2.string(), eventType: z2.string(), eventKey: z2.string(), deletedFileName: z2.string(), uploadedBy: z2.string() })]);
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/student/{uni}/{studentNo}/scheduled-interview/doc";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/pass
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventName: z.string(), eventKey: z.string(), status: z.enum(['PASSED', 'FAILED', 'RESIT', 'DELETED']).optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pass: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/pass";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const bodySchema = z2.object({ eventType: z2.string(), eventName: z2.string(), eventKey: z2.string(), status: z2.enum(["PASSED", "FAILED", "RESIT", "DELETED"]).optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/pass";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/resit
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        resit: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/resit";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const bodySchema = z2.object({ eventType: z2.string(), eventKey: z2.string(), eventName: z2.string(), note: z2.string(), undo: z2.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/resit";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/fail
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        fail: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/fail";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const bodySchema = z2.object({ eventType: z2.string(), eventKey: z2.string(), eventName: z2.string(), note: z2.string(), undo: z2.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/fail";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/request
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.object({ id: z.string().nullable(), schedulingUrl: z.string().optional(), name: z.string().optional(), description: z.string().optional() }), note: z.string().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        request: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/request";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const bodySchema = z2.object({ eventType: z2.object({ id: z2.string().nullable(), schedulingUrl: z2.string().optional(), name: z2.string().optional(), description: z2.string().optional() }), note: z2.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/request";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/cancel
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), note: z.string() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        cancel: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/cancel";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const bodySchema = z2.object({ eventType: z2.string(), eventKey: z2.string(), note: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/cancel";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      RecordedInterview: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        request: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pass: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        resit: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        fail: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        cancel: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<{ interviews: Record<string, IRecordedInterviewEntry> }>>
         */
        exceeded: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CredibilityInterview: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        reset: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      OfferEvidence: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      VisaStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Conflict: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Agents: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/agents
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      TravelStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      AccomodationStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      visaSupport: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      interviewImages: (() => {
        const method = "GET";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateUniStudentNo: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateStatus: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ActiveOffers: {
      /**
       * GET /student/{uni}/{studentNo}/active-offers
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<Array<IActiveOffer>>>
       */
      get: (() => {
        const method = "GET";
        const path = "/student/{uni}/{studentNo}/active-offers";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/active-offers";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/active-offers
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/active-offers";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/active-offers";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Document: {
      /**
       * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      noDoc: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      applied: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      replaced: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateStatus: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      requestCustom: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /visaStatusUpdate
     * @returns Promise<ApiResponse<unknown>>
     */
    visaStatus: (() => {
      const method = "GET";
      const path = "/visaStatusUpdate";
      const buildUrl = () => "/visaStatusUpdate";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * GET /confirmArrival
     * @returns Promise<ApiResponse<unknown>>
     */
    confirmArrival: (() => {
      const method = "GET";
      const path = "/confirmArrival";
      const buildUrl = () => "/confirmArrival";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * DELETE /student/{uni}/{studentNo}/importHash
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    importHashClear: (() => {
      const method = "DELETE";
      const path = "/student/{uni}/{studentNo}/importHash";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{uni}/{studentNo}/importHash";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /transfer-mate/update-status/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    transferMate: (() => {
      const method = "POST";
      const path = "/transfer-mate/update-status/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/transfer-mate/update-status/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /student/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    changeStudentNo: (() => {
      const method = "PUT";
      const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<GetStudentResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentAuditResponse>>
     */
    audit: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentDocsResponse>>
     */
    docs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFinDocsResponse>>
     */
    finDocs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFollowUpDocsResponse>>
     */
    followUpDocs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentMessagesResponse>>
     */
    messages: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentEmailsResponse>>
     */
    emails: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentRecordedInterviewResponse>>
     */
    recordedInterview: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Unsubscribe: {
    /**
     * POST /unsubscribe
     * @returns Promise<ApiResponse<APIResponse>>
     */
    unsubscribe: (() => {
      const method = "POST";
      const path = "/unsubscribe";
      const buildUrl = () => "/unsubscribe";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  MeetingManager: {
    CalendlyWebhooks: {
      /**
       * POST /calendly/webhooks
       * @returns Promise<ApiResponse<void>>
       */
      post: (() => {
        const method = "POST";
        const path = "/calendly/webhooks";
        const buildUrl = () => "/calendly/webhooks";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    }
  },
  Config: {
    ScheduledInterviews: {
      Uni: {
        EventTypes: {
          /**
           * GET /event-types/{uni}
           * @pathParams {uni: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/event-types/{uni}";
            const pathParamsSchema = z2.object({ uni: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/event-types/{uni}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        Config: {
          /**
           * POST /calendly-auth/config/{uni}
           * @pathParams {uni: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/calendly-auth/config/{uni}";
            const pathParamsSchema = z2.object({ uni: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/calendly-auth/config/{uni}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        }
      },
      Pathway: {
        EventTypes: {
          /**
           * GET /event-types/{uni}/pathway/{pathway}
           * @pathParams {uni: string, pathway: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/event-types/{uni}/pathway/{pathway}";
            const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/event-types/{uni}/pathway/{pathway}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        }
      }
    },
    Uni: {
      RegionOffices: {
        /**
         * GET /offices/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionOffice[]>>
         */
        list: (() => {
          const method = "GET";
          const path = "/offices/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionOffice: {
        /**
         * GET /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        get: (() => {
          const method = "GET";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /offices/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        create: (() => {
          const method = "POST";
          const path = "/offices/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      ProgrammableTags: {
        /**
         * GET /programmable-tags/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IProgrammableTag[]>>
         */
        list: (() => {
          const method = "GET";
          const path = "/programmable-tags/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      ProgrammableTag: {
        /**
         * POST /programmable-tags/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IProgrammableTag>>
         */
        create: (() => {
          const method = "POST";
          const path = "/programmable-tags/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /programmable-tags/{uni}/applied
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<AppliedCountResponse>>
         */
        getAppliedCount: (() => {
          const method = "PUT";
          const path = "/programmable-tags/{uni}/applied";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/applied";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /programmable-tags/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IProgrammableTag>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/programmable-tags/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /programmable-tags/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<string>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/programmable-tags/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Tags: {
        /**
         * GET /config/uni/{uni}/tags
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ITag[] | APIResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/tags";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/tags";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Tag: {
        /**
         * POST /config/uni/{uni}/tags
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ITag[] | APIResponse>>
         */
        create: (() => {
          const method = "POST";
          const path = "/config/uni/{uni}/tags";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/tags";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /config/uni/{uni}/tags/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ITag | APIResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/tags/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/tags/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/uni/{uni}/tags/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ITag | APIResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/uni/{uni}/tags/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/tags/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/uni/{uni}/tags/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<{ count: number }>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/uni/{uni}/tags/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/tags/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionConfigs: {
        /**
         * GET /config/uni/{uni}/region
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters[]>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/region";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /config/uni/{uni}/region/all-pathway
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters[]>>
         */
        getAllPathway: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/region/all-pathway";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/all-pathway";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionConfig: {
        /**
         * POST /config/uni/{uni}/region
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        new: (() => {
          const method = "POST";
          const path = "/config/uni/{uni}/region";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /config/uni/{uni}/region/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/uni/{uni}/region/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<string>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/uni/{uni}/region/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      InterviewConfigs: {
        /**
         * GET /config/uni/{uni}/region/interview
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionInterviewConfig[]>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/region/interview";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      InterviewConfig: {
        /**
         * GET /config/uni/{uni}/region/interview/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionInterviewConfig>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/interview/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /config/uni/{uni}/region/interview
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<void>>
         */
        new: (() => {
          const method = "POST";
          const path = "/config/uni/{uni}/region/interview";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/uni/{uni}/region/interview/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/interview/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/uni/{uni}/region/interview/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/region/interview/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CustomDocuments: {
        /**
         * GET /config/uni/{uni}/custom-docs-settings
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IGlobalCustomDocuments>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/uni/{uni}/custom-docs-settings";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/custom-docs-settings";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/uni/{uni}/custom-docs-settings
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IGlobalCustomDocuments>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/uni/{uni}/custom-docs-settings";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/uni/{uni}/custom-docs-settings";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      SITS: {
        /**
         * POST /config/{uni}/sits
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ISITS>>
         */
        update: (() => {
          const method = "POST";
          const path = "/config/{uni}/sits";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/{uni}/sits";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Oracle: {
        /**
         * POST /config/{uni}/oracle
         * @pathParams {uni: string}
         * @body z.object({ oracleEnabled: z.boolean(), oracleUrl: z.string(), oracleUserName: z.string().optional(), oraclePassword: z.string().optional(), oracleValueMappings: z.array(z.object({ fieldType: z.string(), values: z.array(z.object({ source: z.string(), target: z.string() })) })).optional() })
         * @returns Promise<ApiResponse<IOracle>>
         */
        update: (() => {
          const method = "POST";
          const path = "/config/{uni}/oracle";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const bodySchema = z2.object({ oracleEnabled: z2.boolean(), oracleUrl: z2.string(), oracleUserName: z2.string().optional(), oraclePassword: z2.string().optional(), oracleValueMappings: z2.array(z2.object({ fieldType: z2.string(), values: z2.array(z2.object({ source: z2.string(), target: z2.string() })) })).optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/{uni}/oracle";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Ellucian: {
        /**
         * POST /config/{uni}/ellucian
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IEllucian>>
         */
        update: (() => {
          const method = "POST";
          const path = "/config/{uni}/ellucian";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/{uni}/ellucian";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    SpecialMaps: {
      Uni: {
        /**
         * GET /special-map/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ISpecialMap[] | APIResponse>>
         */
        list: (() => {
          const method = "GET";
          const path = "/special-map/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-map/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /special-map/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ISpecialMap | APIResponse>>
         */
        create: (() => {
          const method = "POST";
          const path = "/special-map/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-map/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /special-map/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ISpecialMap | APIResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/special-map/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-map/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /special-map/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<unknown | APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/special-map/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-map/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /special-map/{uni}/{id}/clone
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ISpecialMap | APIResponse>>
         */
        clone: (() => {
          const method = "POST";
          const path = "/special-map/{uni}/{id}/clone";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-map/{uni}/{id}/clone";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    SpecialDataRules: {
      Uni: {
        /**
         * GET /special-data-rule/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ISpecialDataRule[]>>
         */
        list: (() => {
          const method = "GET";
          const path = "/special-data-rule/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-data-rule/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /special-data-rule/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<ISpecialDataRule>>
         */
        create: (() => {
          const method = "POST";
          const path = "/special-data-rule/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-data-rule/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /special-data-rule/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ISpecialDataRule>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/special-data-rule/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-data-rule/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /special-data-rule/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<string>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/special-data-rule/{uni}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-data-rule/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /special-data-rule/{uni}/{id}/clone
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<ISpecialDataRule>>
         */
        clone: (() => {
          const method = "POST";
          const path = "/special-data-rule/{uni}/{id}/clone";
          const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/special-data-rule/{uni}/{id}/clone";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    SFTP: {
      /**
       * POST /sftp/{uni}
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<boolean>>
       */
      updateSSHKey: (() => {
        const method = "POST";
        const path = "/sftp/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/sftp/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Pathway: {
      ProgrammableTags: {
        /**
         * GET /programmable-tags/{uni}/pathway/{pathway}
         * @pathParams {uni: string, pathway: string}
         * @returns Promise<ApiResponse<IProgrammableTag[]>>
         */
        list: (() => {
          const method = "GET";
          const path = "/programmable-tags/{uni}/pathway/{pathway}";
          const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/pathway/{pathway}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      ProgrammableTag: {
        /**
         * POST /programmable-tags/{uni}/pathway/{pathway}
         * @pathParams {uni: string, pathway: string}
         * @returns Promise<ApiResponse<IProgrammableTag>>
         */
        create: (() => {
          const method = "POST";
          const path = "/programmable-tags/{uni}/pathway/{pathway}";
          const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/pathway/{pathway}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /programmable-tags/{uni}/pathway/{pathway}/applied
         * @pathParams {uni: string, pathway: string}
         * @returns Promise<ApiResponse<AppliedCountResponse>>
         */
        getAppliedCount: (() => {
          const method = "PUT";
          const path = "/programmable-tags/{uni}/pathway/{pathway}/applied";
          const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/pathway/{pathway}/applied";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /programmable-tags/{uni}/pathway/{pathway}/{id}
         * @pathParams {uni: string, pathway: string, id: string}
         * @returns Promise<ApiResponse<IProgrammableTag>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/programmable-tags/{uni}/pathway/{pathway}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/pathway/{pathway}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /programmable-tags/{uni}/pathway/{pathway}/{id}
         * @pathParams {uni: string, pathway: string, id: string}
         * @returns Promise<ApiResponse<string>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/programmable-tags/{uni}/pathway/{pathway}/{id}";
          const pathParamsSchema = z2.object({ uni: z2.string(), pathway: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/programmable-tags/{uni}/pathway/{pathway}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionConfigs: {
        /**
         * GET /config/pathway/{pathway}/uni/{uni}/region
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters[]>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/pathway/{pathway}/uni/{uni}/region";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionConfig: {
        /**
         * POST /config/pathway/{pathway}/uni/{uni}/region
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        new: (() => {
          const method = "POST";
          const path = "/config/pathway/{pathway}/uni/{uni}/region";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /config/pathway/{pathway}/uni/{uni}/region/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/pathway/{pathway}/uni/{uni}/region/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<string>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/pathway/{pathway}/uni/{uni}/region/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionConfigWithFilters>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      InterviewConfigs: {
        /**
         * GET /config/pathway/{pathway}/uni/{uni}/region/interview
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<IRegionInterviewConfig[]>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/interview";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/interview";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      InterviewConfig: {
        /**
         * GET /config/pathway/{pathway}/uni/{uni}/region/interview/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionInterviewConfig>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /config/pathway/{pathway}/uni/{uni}/region/interview
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<void>>
         */
        new: (() => {
          const method = "POST";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/interview";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/interview";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/pathway/{pathway}/uni/{uni}/region/interview/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/pathway/{pathway}/uni/{uni}/region/interview/{id}
         * @pathParams {pathway: string, uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), id: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/region/interview/{id}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CustomDocuments: {
        /**
         * GET /config/pathway/{pathway}/uni/{uni}/custom-docs-settings
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<IGlobalCustomDocuments>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/pathway/{pathway}/uni/{uni}/custom-docs-settings";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/custom-docs-settings";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /config/pathway/{pathway}/uni/{uni}/custom-docs-settings
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<IGlobalCustomDocuments>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/config/pathway/{pathway}/uni/{uni}/custom-docs-settings";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/pathway/{pathway}/uni/{uni}/custom-docs-settings";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    Cache: {
      Hash: {
        /**
         * GET /config/cache/{cacheKey}/{hashKey}
         * @pathParams {cacheKey: string, hashKey: string}
         * @returns Promise<ApiResponse<any>>
         */
        get: (() => {
          const method = "GET";
          const path = "/config/cache/{cacheKey}/{hashKey}";
          const pathParamsSchema = z2.object({ cacheKey: z2.string(), hashKey: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/cache/{cacheKey}/{hashKey}";
              url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
              url = url.replace("{hashKey}", encodeURIComponent(String(validated.hashKey)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /config/cache/{cacheKey}/{hashKey}
         * @pathParams {cacheKey: string, hashKey: string}
         * @returns Promise<ApiResponse<any>>
         */
        post: (() => {
          const method = "POST";
          const path = "/config/cache/{cacheKey}/{hashKey}";
          const pathParamsSchema = z2.object({ cacheKey: z2.string(), hashKey: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/cache/{cacheKey}/{hashKey}";
              url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
              url = url.replace("{hashKey}", encodeURIComponent(String(validated.hashKey)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /config/cache/{cacheKey}/{hashKey}
         * @pathParams {cacheKey: string, hashKey: string}
         * @returns Promise<ApiResponse<any>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/config/cache/{cacheKey}/{hashKey}";
          const pathParamsSchema = z2.object({ cacheKey: z2.string(), hashKey: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/config/cache/{cacheKey}/{hashKey}";
              url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
              url = url.replace("{hashKey}", encodeURIComponent(String(validated.hashKey)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /config/cache/${cacheKey}
       * @pathParams {cacheKey: string}
       * @returns Promise<ApiResponse<any>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/cache/${cacheKey}";
        const pathParamsSchema = z2.object({ cacheKey: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/cache/${cacheKey}";
            url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /config/cache/${cacheKey}
       * @pathParams {cacheKey: string}
       * @returns Promise<ApiResponse<any>>
       */
      post: (() => {
        const method = "POST";
        const path = "/config/cache/${cacheKey}";
        const pathParamsSchema = z2.object({ cacheKey: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/cache/${cacheKey}";
            url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /config/cache/${cacheKey}/
       * @pathParams {cacheKey: string}
       * @returns Promise<ApiResponse<any>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/config/cache/${cacheKey}/";
        const pathParamsSchema = z2.object({ cacheKey: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/cache/${cacheKey}/";
            url = url.replace("{cacheKey}", encodeURIComponent(String(validated.cacheKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /config/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<Partial<ISystemAndUniConfig> | APIResponse>>
     */
    getUniConfig: (() => {
      const method = "GET";
      const path = "/config/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/config/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /config/uni/{uni}/navigation-urls
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    getNavigationUrls: (() => {
      const method = "GET";
      const path = "/config/uni/{uni}/navigation-urls";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/config/uni/{uni}/navigation-urls";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /config
     * @returns Promise<ApiResponse<Partial<ISystemAndUniConfig> | APIResponse>>
     */
    post: (() => {
      const method = "POST";
      const path = "/config";
      const buildUrl = () => "/config";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /config/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<IUniConfig | APIResponse>>
     */
    updateUniConfig: (() => {
      const method = "POST";
      const path = "/config/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/config/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /config-noauth/{uni}/university-name
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<{ uniName: string } | APIResponse>>
     */
    getUniName: (() => {
      const method = "GET";
      const path = "/config-noauth/{uni}/university-name";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/config-noauth/{uni}/university-name";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /config/feature-flags
     * @returns Promise<ApiResponse<Record<string, boolean> | APIResponse>>
     */
    getFeatureFlags: (() => {
      const method = "GET";
      const path = "/config/feature-flags";
      const buildUrl = () => "/config/feature-flags";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  Apply: {
    CalendlyInterview: {
      SchedulingInfo: {
        /**
         * GET /event-types/{uni}/{eventTypeUuid}/scheduling-info
         * @pathParams {uni: string, eventTypeUuid: string}
         * @returns Promise<ApiResponse<SchedulingInfoResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/event-types/{uni}/{eventTypeUuid}/scheduling-info";
          const pathParamsSchema = z2.object({ uni: z2.string(), eventTypeUuid: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/event-types/{uni}/{eventTypeUuid}/scheduling-info";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{eventTypeUuid}", encodeURIComponent(String(validated.eventTypeUuid ?? validated.EVENTTYPEUUID ?? validated.eventTypeUuid)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    RecordedInterview: {
      /**
       * GET /interviews/{uni}/apply/{offerId}/{interviewId}/questions
       * @pathParams {uni: string, offerId: string, interviewId: string}
       * @returns Promise<ApiResponse<ApplyRecordedInterviewQuestionsResponse | APIResponse>>
       */
      questions: (() => {
        const method = "GET";
        const path = "/interviews/{uni}/apply/{offerId}/{interviewId}/questions";
        const pathParamsSchema = z2.object({ uni: z2.string(), offerId: z2.string(), interviewId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/apply/{offerId}/{interviewId}/questions";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId ?? validated.INTERVIEWID ?? validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/apply/{offerId}/{interviewId}/check
       * @pathParams {uni: string, offerId: string, interviewId: string}
       * @body z.object({ attemptIndex: z.number() })
       * @returns Promise<ApiResponse<APIResponse>>
       */
      check: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/apply/{offerId}/{interviewId}/check";
        const pathParamsSchema = z2.object({ uni: z2.string(), offerId: z2.string(), interviewId: z2.string() });
        const bodySchema = z2.object({ attemptIndex: z2.number() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/apply/{offerId}/{interviewId}/check";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId ?? validated.INTERVIEWID ?? validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    Agent: {
      Courses: {
        /**
         * GET /apply/agent/{uni}/courses
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<unknown>>
         */
        list: (() => {
          const method = "GET";
          const path = "/apply/agent/{uni}/courses";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/agent/{uni}/courses";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Authorize: {
        /**
         * GET /apply-noauth/student-authorise-agent
         * @returns Promise<ApiResponse<Partial<ILead> | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply-noauth/student-authorise-agent";
          const buildUrl = () => "/apply-noauth/student-authorise-agent";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /apply-noauth/student-authorise-agent
         * @body StudentAuthoriseAgentSchema
         * @returns Promise<ApiResponse<UpdateStudentAuthoriseAgentResponse | APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/apply-noauth/student-authorise-agent";
          const bodySchema = StudentAuthoriseAgentSchema;
          const buildUrl = () => "/apply-noauth/student-authorise-agent";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            buildUrl
          });
        })()
      }
    },
    Legal: {
      /**
       * GET /apply-noauth/{uni}/legal
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<GetUniLegalInfoResponse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply-noauth/{uni}/legal";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply-noauth/{uni}/legal";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Applications: {
      /**
       * GET /apply/applications
       * @returns Promise<ApiResponse<GetApplicationsResponse>>
       */
      list: (() => {
        const method = "GET";
        const path = "/apply/applications";
        const buildUrl = () => "/apply/applications";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Application: {
      References: {
        /**
         * GET /apply/application/{applicationId}/references
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetReferencesResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/references";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/references";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/application/{applicationId}/references
         * @pathParams {applicationId: string}
         * @body ReferencesSchema
         * @returns Promise<ApiResponse<UpdateReferencesResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/application/{applicationId}/references";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const bodySchema = ReferencesSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/references";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      PersonalStatement: {
        /**
         * GET /apply/application/{applicationId}/personal-statement
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetPersonalStatementResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/personal-statement";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/personal-statement";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/application/{applicationId}/personal-statement
         * @pathParams {applicationId: string}
         * @body PersonalStatementSchema
         * @returns Promise<ApiResponse<UpdatePersonalStatementResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/application/{applicationId}/personal-statement";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const bodySchema = PersonalStatementSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/personal-statement";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Funding: {
        /**
         * GET /apply/application/{applicationId}/funding
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetFundingPlanResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/funding";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/funding";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/application/{applicationId}/funding
         * @pathParams {applicationId: string}
         * @body z.object({ primaryFundingSource: z.enum(['PrivateFinance', 'StudentFinance', 'HealthAuthority', 'ResearchCouncils', 'TrainingAgency', 'UkIndustry', 'UkGovtInternational', 'UkGovtOther', 'UniversityScholarship', 'OverseasAgency', 'OverseasGovt', 'OverseasIndustry', 'OverseasUniversity', 'Other', 'Unknown']), isPlanningToWork: z.boolean(), otherSourceOfFunding: z.string().nullable().optional(), isSLCGrant: z.boolean().nullable().optional(), isSLCLoan: z.boolean().nullable().optional() })
         * @returns Promise<ApiResponse<UpdateFundingPlanResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/application/{applicationId}/funding";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const bodySchema = z2.object({ primaryFundingSource: z2.enum(["PrivateFinance", "StudentFinance", "HealthAuthority", "ResearchCouncils", "TrainingAgency", "UkIndustry", "UkGovtInternational", "UkGovtOther", "UniversityScholarship", "OverseasAgency", "OverseasGovt", "OverseasIndustry", "OverseasUniversity", "Other", "Unknown"]), isPlanningToWork: z2.boolean(), otherSourceOfFunding: z2.string().nullable().optional(), isSLCGrant: z2.boolean().nullable().optional(), isSLCLoan: z2.boolean().nullable().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/funding";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Representation: {
        /**
         * GET /apply/application/{applicationId}/representation
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetRepresentationResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/representation";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/representation";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/application/{applicationId}/representation
         * @pathParams {applicationId: string}
         * @body RepresentationFormSchema
         * @returns Promise<ApiResponse<UpdateRepresentationResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/application/{applicationId}/representation";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const bodySchema = RepresentationFormSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/representation";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Decleration: {
        /**
         * GET /apply/application/{applicationId}/declarations
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetDeclarationsResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/declarations";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/declarations";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/application/{applicationId}/declarations
         * @pathParams {applicationId: string}
         * @body DeclarationsSchema
         * @returns Promise<ApiResponse<UpdateDeclarationsResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/application/{applicationId}/declarations";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const bodySchema = DeclarationsSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/declarations";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Consent: {
        InformationProcessing: {
          /**
           * POST /apply/application/{applicationId}/information-processing
           * @pathParams {applicationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body InformationProcessingConsentSchema
           * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/apply/application/{applicationId}/information-processing";
            const pathParamsSchema = z2.object({ applicationId: z2.string() });
            const bodySchema = InformationProcessingConsentSchema;
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/application/{applicationId}/information-processing";
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        Privacy: {
          /**
           * POST /apply/application/{applicationId}/privacy-policy
           * @pathParams {applicationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body PrivacyPolicyConsentSchema
           * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/apply/application/{applicationId}/privacy-policy";
            const pathParamsSchema = z2.object({ applicationId: z2.string() });
            const bodySchema = PrivacyPolicyConsentSchema;
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/application/{applicationId}/privacy-policy";
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        Terms: {
          /**
           * POST /apply/application/{applicationId}/terms-and-conditions
           * @pathParams {applicationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body TermsAndConditionsConsentSchema
           * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/apply/application/{applicationId}/terms-and-conditions";
            const pathParamsSchema = z2.object({ applicationId: z2.string() });
            const bodySchema = TermsAndConditionsConsentSchema;
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/application/{applicationId}/terms-and-conditions";
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        DataAccuracy: {
          /**
           * POST /apply/application/{applicationId}/data-accuracy
           * @pathParams {applicationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body AccuracyOfDataConsentSchema
           * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/apply/application/{applicationId}/data-accuracy";
            const pathParamsSchema = z2.object({ applicationId: z2.string() });
            const bodySchema = AccuracyOfDataConsentSchema;
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/application/{applicationId}/data-accuracy";
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        /**
         * GET /apply/application/{applicationId}/consent
         * @pathParams {applicationId: string}
         * @returns Promise<ApiResponse<GetConsentsResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/application/{applicationId}/consent";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/application/{applicationId}/consent";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /apply/applications/{applicationId}
       * @pathParams {applicationId: string}
       * @queryParams z.object({ attributes: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicationResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/applications/{applicationId}";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const queryParamsSchema = z2.object({ attributes: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/applications/{applicationId}";
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/application/{applicationId}/submit
       * @pathParams {applicationId: string}
       * @returns Promise<ApiResponse<SubmitApplicationResponse | ErrorResponse>>
       */
      submit: (() => {
        const method = "POST";
        const path = "/apply/application/{applicationId}/submit";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/application/{applicationId}/submit";
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Welcome: {
      /**
       * GET /apply/welcome
       * @returns Promise<ApiResponse<WelcomeGetResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/welcome";
        const buildUrl = () => "/apply/welcome";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /apply/welcome
       * @returns Promise<ApiResponse<WelcomePostResponse | GetErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/welcome";
        const buildUrl = () => "/apply/welcome";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Preferences: {
      /**
       * GET /apply/preferences
       * @returns Promise<ApiResponse<GetPreferencesResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/preferences";
        const buildUrl = () => "/apply/preferences";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /apply/preferences
       * @body z.object({ analyticsConsent: z.unknown().optional() })
       * @returns Promise<ApiResponse<UpdatePreferencesResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/preferences";
        const bodySchema = z2.object({ analyticsConsent: z2.unknown().optional() });
        const buildUrl = () => "/apply/preferences";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    Applicant: {
      FeeStatus: {
        /**
         * GET /apply/applicant/fee-status
         * @returns Promise<ApiResponse<GetFeeStatusResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/fee-status";
          const buildUrl = () => "/apply/applicant/fee-status";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/fee-status
         * @body FeeStatusSchema
         * @returns Promise<ApiResponse<UpdateFeeStatusResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/fee-status";
          const bodySchema = FeeStatusSchema;
          const buildUrl = () => "/apply/applicant/fee-status";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            buildUrl
          });
        })()
      },
      ContactInformation: {
        /**
         * GET /apply/applicant/contact-information
         * @returns Promise<ApiResponse<GetContactInformationResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/contact-information";
          const buildUrl = () => "/apply/applicant/contact-information";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/contact-information
         * @body ContactInformationSchema
         * @returns Promise<ApiResponse<UpdateContactInformationResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/contact-information";
          const bodySchema = ContactInformationSchema;
          const buildUrl = () => "/apply/applicant/contact-information";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            buildUrl
          });
        })()
      },
      ProgrammeChoices: {
        /**
         * GET /apply/applicant/programme-choices
         * @returns Promise<ApiResponse<unknown>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/programme-choices";
          const buildUrl = () => "/apply/applicant/programme-choices";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/programme-choices
         * @body ProgrammeChoicesSchema
         * @returns Promise<ApiResponse<unknown>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/programme-choices";
          const bodySchema = ProgrammeChoicesSchema;
          const buildUrl = () => "/apply/applicant/programme-choices";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/additional-programme-choices
         * @body ProgrammeChoicesSchema
         * @returns Promise<ApiResponse<unknown>>
         */
        add: (() => {
          const method = "POST";
          const path = "/apply/applicant/additional-programme-choices";
          const bodySchema = ProgrammeChoicesSchema;
          const buildUrl = () => "/apply/applicant/additional-programme-choices";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            buildUrl
          });
        })()
      },
      tCourses: {
        /**
         * GET /apply/applicant/courses
         * @returns Promise<ApiResponse<unknown>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/courses";
          const buildUrl = () => "/apply/applicant/courses";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })()
      },
      Identity: {
        /**
         * GET /apply/applicant/identity
         * @queryParams z.object({ applicationId: z.string() })
         * @returns Promise<ApiResponse<GetApplicantIdentityResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/identity";
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/identity";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/identity
         * @queryParams z.object({ applicationId: z.string() })
         * @body ApplicantIdentitySchema
         * @returns Promise<ApiResponse<UpdateApplicantIdentityResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/identity";
          const bodySchema = ApplicantIdentitySchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/identity";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Nationaity: {
        /**
         * GET /apply/applicant/nationality-and-residence
         * @queryParams z.object({ applicationId: z.string() })
         * @returns Promise<ApiResponse<GetNationalityResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/nationality-and-residence";
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/nationality-and-residence";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/nationality-and-residence
         * @queryParams z.object({ applicationId: z.string() })
         * @body NationalitySchema
         * @returns Promise<ApiResponse<UpdateNationalityResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/nationality-and-residence";
          const bodySchema = NationalitySchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/nationality-and-residence";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      ContactDetails: {
        /**
         * GET /apply/applicant/contact-details
         * @queryParams z.object({ applicationId: z.string() })
         * @returns Promise<ApiResponse<GetContactDetailsResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/contact-details";
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/contact-details";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/contact-details
         * @queryParams z.object({ applicationId: z.string() })
         * @body z.object({ residentialPhoneNo: z.string(), contactAddressSameAsResidential: z.boolean(), residentialAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), country: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }).nullable(), contactAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), country: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }).nullable(), termAddressSameAsPermanent: z.boolean().nullable().optional(), termAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }).nullable(), hasUkAccommodation: z.boolean().nullable().optional(), ukAccommodationType: z.string().nullable().optional(), ukAccommodationAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }).nullable(), ukAccommodationPhone: z.string().nullable().optional() })
         * @returns Promise<ApiResponse<UpdateContactDetailsResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/contact-details";
          const bodySchema = z2.object({ residentialPhoneNo: z2.string(), contactAddressSameAsResidential: z2.boolean(), residentialAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), country: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }).nullable(), contactAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), country: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }).nullable(), termAddressSameAsPermanent: z2.boolean().nullable().optional(), termAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }).nullable(), hasUkAccommodation: z2.boolean().nullable().optional(), ukAccommodationType: z2.string().nullable().optional(), ukAccommodationAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }).nullable(), ukAccommodationPhone: z2.string().nullable().optional() });
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/contact-details";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      StudyHistory: {
        HighestStudy: {
          /**
           * POST /apply/applicant/study-history/highest/complete
           * @returns Promise<ApiResponse<CompleteLatestEducationQualificationsResponse | ErrorResponse>>
           */
          complete: (() => {
            const method = "POST";
            const path = "/apply/applicant/study-history/highest/complete";
            const buildUrl = () => "/apply/applicant/study-history/highest/complete";
            const fn = async (args) => {
              let url = buildUrl();
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              buildUrl
            });
          })(),
          /**
           * DELETE /apply/applicant/study-history/highest
           * @returns Promise<ApiResponse<RemoveStudyHistoryResponse>>
           */
          delete: (() => {
            const method = "DELETE";
            const path = "/apply/applicant/study-history/highest";
            const buildUrl = () => "/apply/applicant/study-history/highest";
            const fn = async (args) => {
              let url = buildUrl();
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              buildUrl
            });
          })()
        },
        Qualification: {
          /**
           * POST /apply/applicant/study-history/{studyHistoryId}/qualifications
           * @pathParams {studyHistoryId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body z.object({ grade: z.string(), gradeSystem: z.string(), subject: z.string().optional(), level: z.string().optional(), qualificationTypeLabel: z.string().optional(), groupId: z.string().optional(), levelLabel: z.string().optional(), qualificationTypeId: z.string().optional(), otherQualificationName: z.string().nullable().optional(), gradeSystemLabel: z.string().optional(), qualificationTypeRowId: z.string().optional(), graduationDate: z.string().optional(), awardingOrganisationId: z.string().optional(), awardingOrganisationLabel: z.string().optional(), awardingOrganisationVisible: z.boolean().optional(), modulesVisible: z.boolean().optional(), subjectsVisible: z.boolean().optional(), modules: z.array(z.object({ subject: z.string(), grade: z.string() })).optional() })
           * @returns Promise<ApiResponse<CreateQualificationResponse>>
           */
          add: (() => {
            const method = "POST";
            const path = "/apply/applicant/study-history/{studyHistoryId}/qualifications";
            const pathParamsSchema = z2.object({ studyHistoryId: z2.string().optional() });
            const bodySchema = z2.object({ grade: z2.string(), gradeSystem: z2.string(), subject: z2.string().optional(), level: z2.string().optional(), qualificationTypeLabel: z2.string().optional(), groupId: z2.string().optional(), levelLabel: z2.string().optional(), qualificationTypeId: z2.string().optional(), otherQualificationName: z2.string().nullable().optional(), gradeSystemLabel: z2.string().optional(), qualificationTypeRowId: z2.string().optional(), graduationDate: z2.string().optional(), awardingOrganisationId: z2.string().optional(), awardingOrganisationLabel: z2.string().optional(), awardingOrganisationVisible: z2.boolean().optional(), modulesVisible: z2.boolean().optional(), subjectsVisible: z2.boolean().optional(), modules: z2.array(z2.object({ subject: z2.string(), grade: z2.string() })).optional() });
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/{studyHistoryId}/qualifications";
                url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}
           * @pathParams {studyHistoryId: string, qualificationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @body z.object({ grade: z.string(), gradeSystem: z.string(), subject: z.string().optional(), level: z.string().optional(), qualificationTypeLabel: z.string().optional(), groupId: z.string().optional(), levelLabel: z.string().optional(), qualificationTypeId: z.string().optional(), otherQualificationName: z.string().nullable().optional(), gradeSystemLabel: z.string().optional(), qualificationTypeRowId: z.string().optional(), graduationDate: z.string().optional(), awardingOrganisationId: z.string().optional(), awardingOrganisationLabel: z.string().optional(), awardingOrganisationVisible: z.boolean().optional(), modulesVisible: z.boolean().optional(), subjectsVisible: z.boolean().optional(), modules: z.array(z.object({ subject: z.string(), grade: z.string() })).optional() })
           * @returns Promise<ApiResponse<UpdateQualificationResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}";
            const pathParamsSchema = z2.object({ qualificationId: z2.string(), studyHistoryId: z2.string().optional() });
            const bodySchema = z2.object({ grade: z2.string(), gradeSystem: z2.string(), subject: z2.string().optional(), level: z2.string().optional(), qualificationTypeLabel: z2.string().optional(), groupId: z2.string().optional(), levelLabel: z2.string().optional(), qualificationTypeId: z2.string().optional(), otherQualificationName: z2.string().nullable().optional(), gradeSystemLabel: z2.string().optional(), qualificationTypeRowId: z2.string().optional(), graduationDate: z2.string().optional(), awardingOrganisationId: z2.string().optional(), awardingOrganisationLabel: z2.string().optional(), awardingOrganisationVisible: z2.boolean().optional(), modulesVisible: z2.boolean().optional(), subjectsVisible: z2.boolean().optional(), modules: z2.array(z2.object({ subject: z2.string(), grade: z2.string() })).optional() });
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}";
                url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
                url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId ?? validated.QUALIFICATIONID ?? validated.qualificationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              queryParamsSchema,
              buildUrl
            });
          })(),
          /**
           * DELETE /apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}
           * @pathParams {studyHistoryId: string, qualificationId: string}
           * @queryParams z.object({ applicationId: z.string() })
           * @returns Promise<ApiResponse<RemoveQualificationResponse>>
           */
          delete: (() => {
            const method = "DELETE";
            const path = "/apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}";
            const pathParamsSchema = z2.object({ qualificationId: z2.string(), studyHistoryId: z2.string().optional() });
            const queryParamsSchema = z2.object({ applicationId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/{studyHistoryId}/qualifications/{qualificationId}";
                url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
                url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId ?? validated.QUALIFICATIONID ?? validated.qualificationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        Institution: {
          Study: {
            Qualification: {
              /**
               * POST /apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
               * @pathParams {institutionId: string, studyId: string, qualificationId: string}
               * @returns Promise<ApiResponse<unknown>>
               */
              add: (() => {
                const method = "POST";
                const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
                const buildUrl = (params) => {
                  try {
                    const validated = pathParamsSchema.parse(params);
                    let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                    url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                    url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                    url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
                    return url;
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "path parameters");
                      console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                const fn = async (args) => {
                  let url = buildUrl(args.pathParams);
                  if (args.queryParams) {
                    const queryString = buildQueryString(args.queryParams);
                    if (queryString) url += "?" + queryString;
                  }
                  return makeRequest(method, url, args.body, args.options);
                };
                return Object.assign(fn, {
                  method,
                  path,
                  pathParamsSchema,
                  buildUrl
                });
              })(),
              /**
               * PUT /apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
               * @pathParams {institutionId: string, studyId: string, qualificationId: string}
               * @returns Promise<ApiResponse<unknown>>
               */
              edit: (() => {
                const method = "PUT";
                const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
                const buildUrl = (params) => {
                  try {
                    const validated = pathParamsSchema.parse(params);
                    let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                    url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                    url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                    url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
                    return url;
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "path parameters");
                      console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                const fn = async (args) => {
                  let url = buildUrl(args.pathParams);
                  if (args.queryParams) {
                    const queryString = buildQueryString(args.queryParams);
                    if (queryString) url += "?" + queryString;
                  }
                  return makeRequest(method, url, args.body, args.options);
                };
                return Object.assign(fn, {
                  method,
                  path,
                  pathParamsSchema,
                  buildUrl
                });
              })(),
              /**
               * GET /apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
               * @pathParams {institutionId: string, studyId: string, qualificationId: string}
               * @returns Promise<ApiResponse<unknown>>
               */
              get: (() => {
                const method = "GET";
                const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
                const buildUrl = (params) => {
                  try {
                    const validated = pathParamsSchema.parse(params);
                    let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                    url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                    url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                    url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
                    return url;
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "path parameters");
                      console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                const fn = async (args) => {
                  let url = buildUrl(args.pathParams);
                  if (args.queryParams) {
                    const queryString = buildQueryString(args.queryParams);
                    if (queryString) url += "?" + queryString;
                  }
                  return makeRequest(method, url, args.body, args.options);
                };
                return Object.assign(fn, {
                  method,
                  path,
                  pathParamsSchema,
                  buildUrl
                });
              })(),
              /**
               * DELETE /apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
               * @pathParams {institutionId: string, studyId: string, qualificationId: string}
               * @returns Promise<ApiResponse<unknown>>
               */
              delete: (() => {
                const method = "DELETE";
                const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
                const buildUrl = (params) => {
                  try {
                    const validated = pathParamsSchema.parse(params);
                    let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
                    url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                    url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                    url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
                    return url;
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "path parameters");
                      console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                const fn = async (args) => {
                  let url = buildUrl(args.pathParams);
                  if (args.queryParams) {
                    const queryString = buildQueryString(args.queryParams);
                    if (queryString) url += "?" + queryString;
                  }
                  return makeRequest(method, url, args.body, args.options);
                };
                return Object.assign(fn, {
                  method,
                  path,
                  pathParamsSchema,
                  buildUrl
                });
              })()
            },
            /**
             * POST /apply/applicant/study-history/institution/{institutionId}/study/{studyId}
             * @pathParams {institutionId: string, studyId: string}
             * @returns Promise<ApiResponse<unknown>>
             */
            add: (() => {
              const method = "POST";
              const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
              const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string() });
              const buildUrl = (params) => {
                try {
                  const validated = pathParamsSchema.parse(params);
                  let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
                  url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                  url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                  return url;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "path parameters");
                    console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              const fn = async (args) => {
                let url = buildUrl(args.pathParams);
                if (args.queryParams) {
                  const queryString = buildQueryString(args.queryParams);
                  if (queryString) url += "?" + queryString;
                }
                return makeRequest(method, url, args.body, args.options);
              };
              return Object.assign(fn, {
                method,
                path,
                pathParamsSchema,
                buildUrl
              });
            })(),
            /**
             * PUT /apply/applicant/study-history/institution/{institutionId}/study/{studyId}
             * @pathParams {institutionId: string, studyId: string}
             * @returns Promise<ApiResponse<unknown>>
             */
            edit: (() => {
              const method = "PUT";
              const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
              const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string() });
              const buildUrl = (params) => {
                try {
                  const validated = pathParamsSchema.parse(params);
                  let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
                  url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                  url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                  return url;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "path parameters");
                    console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              const fn = async (args) => {
                let url = buildUrl(args.pathParams);
                if (args.queryParams) {
                  const queryString = buildQueryString(args.queryParams);
                  if (queryString) url += "?" + queryString;
                }
                return makeRequest(method, url, args.body, args.options);
              };
              return Object.assign(fn, {
                method,
                path,
                pathParamsSchema,
                buildUrl
              });
            })(),
            /**
             * GET /apply/applicant/study-history/institution/{institutionId}/study/{studyId}
             * @pathParams {institutionId: string, studyId: string}
             * @returns Promise<ApiResponse<unknown>>
             */
            get: (() => {
              const method = "GET";
              const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
              const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string() });
              const buildUrl = (params) => {
                try {
                  const validated = pathParamsSchema.parse(params);
                  let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
                  url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                  url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                  return url;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "path parameters");
                    console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              const fn = async (args) => {
                let url = buildUrl(args.pathParams);
                if (args.queryParams) {
                  const queryString = buildQueryString(args.queryParams);
                  if (queryString) url += "?" + queryString;
                }
                return makeRequest(method, url, args.body, args.options);
              };
              return Object.assign(fn, {
                method,
                path,
                pathParamsSchema,
                buildUrl
              });
            })(),
            /**
             * DELETE /apply/applicant/study-history/institution/{institutionId}/study/{studyId}
             * @pathParams {institutionId: string, studyId: string}
             * @returns Promise<ApiResponse<unknown>>
             */
            delete: (() => {
              const method = "DELETE";
              const path = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
              const pathParamsSchema = z2.object({ institutionId: z2.string(), studyId: z2.string() });
              const buildUrl = (params) => {
                try {
                  const validated = pathParamsSchema.parse(params);
                  let url = "/apply/applicant/study-history/institution/{institutionId}/study/{studyId}";
                  url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                  url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
                  return url;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "path parameters");
                    console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              const fn = async (args) => {
                let url = buildUrl(args.pathParams);
                if (args.queryParams) {
                  const queryString = buildQueryString(args.queryParams);
                  if (queryString) url += "?" + queryString;
                }
                return makeRequest(method, url, args.body, args.options);
              };
              return Object.assign(fn, {
                method,
                path,
                pathParamsSchema,
                buildUrl
              });
            })()
          },
          /**
           * POST /apply/applicant/study-history/institution/{institutionId}
           * @pathParams {institutionId: string}
           * @returns Promise<ApiResponse<unknown>>
           */
          add: (() => {
            const method = "POST";
            const path = "/apply/applicant/study-history/institution/{institutionId}";
            const pathParamsSchema = z2.object({ institutionId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/institution/{institutionId}";
                url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/applicant/study-history/institution/{institutionId}
           * @pathParams {institutionId: string}
           * @returns Promise<ApiResponse<unknown>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/applicant/study-history/institution/{institutionId}";
            const pathParamsSchema = z2.object({ institutionId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/institution/{institutionId}";
                url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })(),
          /**
           * GET /apply/applicant/study-history/institution/{institutionId}
           * @pathParams {institutionId: string}
           * @returns Promise<ApiResponse<unknown>>
           */
          get: (() => {
            const method = "GET";
            const path = "/apply/applicant/study-history/institution/{institutionId}";
            const pathParamsSchema = z2.object({ institutionId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/institution/{institutionId}";
                url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })(),
          /**
           * DELETE /apply/applicant/study-history/institution/{institutionId}
           * @pathParams {institutionId: string}
           * @returns Promise<ApiResponse<unknown>>
           */
          delete: (() => {
            const method = "DELETE";
            const path = "/apply/applicant/study-history/institution/{institutionId}";
            const pathParamsSchema = z2.object({ institutionId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/applicant/study-history/institution/{institutionId}";
                url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        /**
         * GET /apply/applicant/study-history
         * @returns Promise<ApiResponse<GetStudyHistoryResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/study-history";
          const buildUrl = () => "/apply/applicant/study-history";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/study-history/previous/{studyHistoryId}
         * @pathParams {studyHistoryId: string}
         * @queryParams z.object({ applicationId: z.string() })
         * @body StudySchema
         * @returns Promise<ApiResponse<UpdatePreviousStudyHistoryResponse | ErrorResponse>>
         */
        upsert: (() => {
          const method = "POST";
          const path = "/apply/applicant/study-history/previous/{studyHistoryId}";
          const pathParamsSchema = z2.object({ studyHistoryId: z2.string() });
          const bodySchema = StudySchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/applicant/study-history/previous/{studyHistoryId}";
              url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /apply/applicant/study-history/{studyHistoryId}
         * @pathParams {studyHistoryId: string}
         * @queryParams z.object({ applicationId: z.string() })
         * @body z.object({ country: z.string(), resultStatus: z.enum(['FinalResults', 'InterimResults', 'NoResults']), institutionName: z.string(), institutionAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }), date: z.string().optional(), validUntil: z.string().optional(), level: z.enum(['HighSchool', 'Undergraduate', 'Postgraduate']).optional(), taughtInEnglish: z.boolean().optional(), qualificationTypeSelections: z.array(z.object({ qualificationType: z.string(), gradingSystem: z.string(), id: z.string().optional(), resultStatus: z.enum(['FinalResults', 'InterimResults', 'NoResults']).optional(), taughtInEnglish: z.boolean().optional(), qualificationTypeLabel: z.string().optional(), customQualificationTypeName: z.string().optional(), gradingSystemLabel: z.string().optional(), groupId: z.string().optional() })), academicTranscriptDocument: z.object({ s3Keys: z.array(z.string()).nullable(), sKey: z.string().nullable() }).optional(), qualifications: z.object({}).nullable().optional() })
         * @returns Promise<ApiResponse<RemoveStudyHistoryResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/apply/applicant/study-history/{studyHistoryId}";
          const pathParamsSchema = z2.object({ studyHistoryId: z2.string() });
          const bodySchema = z2.object({ country: z2.string(), resultStatus: z2.enum(["FinalResults", "InterimResults", "NoResults"]), institutionName: z2.string(), institutionAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }), date: z2.string().optional(), validUntil: z2.string().optional(), level: z2.enum(["HighSchool", "Undergraduate", "Postgraduate"]).optional(), taughtInEnglish: z2.boolean().optional(), qualificationTypeSelections: z2.array(z2.object({ qualificationType: z2.string(), gradingSystem: z2.string(), id: z2.string().optional(), resultStatus: z2.enum(["FinalResults", "InterimResults", "NoResults"]).optional(), taughtInEnglish: z2.boolean().optional(), qualificationTypeLabel: z2.string().optional(), customQualificationTypeName: z2.string().optional(), gradingSystemLabel: z2.string().optional(), groupId: z2.string().optional() })), academicTranscriptDocument: z2.object({ s3Keys: z2.array(z2.string()).nullable(), sKey: z2.string().nullable() }).optional(), qualifications: z2.object({}).nullable().optional() });
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/applicant/study-history/{studyHistoryId}";
              url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applications/{applicationId}/study-history/complete
         * @pathParams {applicationId: string}
         * @queryParams z.object({ applicationId: z.string() })
         * @returns Promise<ApiResponse<CompletePreviousEducationResponse | ErrorResponse>>
         */
        complete: (() => {
          const method = "POST";
          const path = "/apply/applications/{applicationId}/study-history/complete";
          const pathParamsSchema = z2.object({ applicationId: z2.string() });
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/applications/{applicationId}/study-history/complete";
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Qualifications: {
        /**
         * GET /apply/applicant/qualifications
         * @queryParams z.object({ countryCode: z.string() })
         * @returns Promise<ApiResponse<GetQualificationsResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/qualifications";
          const queryParamsSchema = z2.object({ countryCode: z2.string() });
          const buildUrl = () => "/apply/applicant/qualifications";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      AwardingOrganisations: {
        /**
         * GET /apply/applicant/awarding-organisations
         * @queryParams z.object({ countryCode: z.string(), qualificationTypeId: z.string() })
         * @returns Promise<ApiResponse<GetAwardingOrganisationsResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/awarding-organisations";
          const queryParamsSchema = z2.object({ countryCode: z2.string(), qualificationTypeId: z2.string() });
          const buildUrl = () => "/apply/applicant/awarding-organisations";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      EnglishTest: {
        /**
         * GET /apply/applicant/english-test
         * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
         * @returns Promise<ApiResponse<GetEnglishTestResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/english-test";
          const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
          const buildUrl = () => "/apply/applicant/english-test";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/english-test
         * @queryParams z.object({ applicationId: z.string() })
         * @body EnglishSchema
         * @returns Promise<ApiResponse<UpdateEnglishTestResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/english-test";
          const bodySchema = EnglishSchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/english-test";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Employment: {
        /**
         * GET /apply/applicant/employment
         * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
         * @returns Promise<ApiResponse<GetEmploymentResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/employment";
          const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
          const buildUrl = () => "/apply/applicant/employment";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/employment
         * @queryParams z.object({ applicationId: z.string() })
         * @body ApplicantEmploymentSchema
         * @returns Promise<ApiResponse<UpdateEmploymentResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/employment";
          const bodySchema = ApplicantEmploymentSchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/employment";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      VisaHistory: {
        /**
         * GET /apply/applicant/visa-history
         * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
         * @returns Promise<ApiResponse<GetVisaHistoryResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/visa-history";
          const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
          const buildUrl = () => "/apply/applicant/visa-history";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/visa-history
         * @queryParams z.object({ applicationId: z.string() })
         * @body z.object({ isVisaRequired: z.boolean().nullable().optional(), visaExemptionReason: z.string().nullable().optional(), hasVisaForCurrentOrPreviousUkStudy: z.boolean().nullable().optional(), hasStudentVisaForThisUkStudy: z.boolean().nullable().optional(), ukStudentVisas: z.array(z.object({ studentVisaType: z.string(), levelOfStudy: z.string(), visaReceivedYear: z.number(), isCourseCompleted: z.boolean(), compareCourse: z.string(), visaNotListedCustomValue: z.string().nullable().optional() })), hasEuEeaSwitzerlandExperience: z.boolean().nullable().optional(), hasEuFamilyMember: z.boolean().nullable().optional(), hasNonStudentVisaOrPermit: z.boolean().nullable().optional(), ukNonStudentVisaOrPermit: z.array(z.object({ studentVisaType: z.string(), issuedDate: z.string(), visaNotListedCustomValue: z.string().nullable().optional(), validTill: z.string().optional() })), hasPreviousVisaRefusal: z.boolean().nullable().optional(), ukVisaRefusals: z.array(z.object({ refusedVisaType: z.string(), visaRefusalYear: z.number() })).nullable().optional(), hasPreviousNonUkVisaRefusal: z.boolean().nullable().optional(), nonUkVisaRefusals: z.array(z.object({ visaRefusalYear: z.number(), visaRefusalCountry: z.string(), isStudentVisaRefused: z.boolean() })).nullable().optional() })
         * @returns Promise<ApiResponse<UpdateVisaHistoryResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/visa-history";
          const bodySchema = z2.object({ isVisaRequired: z2.boolean().nullable().optional(), visaExemptionReason: z2.string().nullable().optional(), hasVisaForCurrentOrPreviousUkStudy: z2.boolean().nullable().optional(), hasStudentVisaForThisUkStudy: z2.boolean().nullable().optional(), ukStudentVisas: z2.array(z2.object({ studentVisaType: z2.string(), levelOfStudy: z2.string(), visaReceivedYear: z2.number(), isCourseCompleted: z2.boolean(), compareCourse: z2.string(), visaNotListedCustomValue: z2.string().nullable().optional() })), hasEuEeaSwitzerlandExperience: z2.boolean().nullable().optional(), hasEuFamilyMember: z2.boolean().nullable().optional(), hasNonStudentVisaOrPermit: z2.boolean().nullable().optional(), ukNonStudentVisaOrPermit: z2.array(z2.object({ studentVisaType: z2.string(), issuedDate: z2.string(), visaNotListedCustomValue: z2.string().nullable().optional(), validTill: z2.string().optional() })), hasPreviousVisaRefusal: z2.boolean().nullable().optional(), ukVisaRefusals: z2.array(z2.object({ refusedVisaType: z2.string(), visaRefusalYear: z2.number() })).nullable().optional(), hasPreviousNonUkVisaRefusal: z2.boolean().nullable().optional(), nonUkVisaRefusals: z2.array(z2.object({ visaRefusalYear: z2.number(), visaRefusalCountry: z2.string(), isStudentVisaRefused: z2.boolean() })).nullable().optional() });
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/visa-history";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Diversity: {
        /**
         * GET /apply/applicant/diversity
         * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
         * @returns Promise<ApiResponse<GetDiversityResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/diversity";
          const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
          const buildUrl = () => "/apply/applicant/diversity";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/diversity
         * @queryParams z.object({ applicationId: z.string() })
         * @body z.object({ occupation: z.string().nullable(), ethnicity: z.enum(['Arab', 'Asian - Bangladeshi', 'Asian - Chinese', 'Asian - Indian', 'Asian - Pakistani', 'Asian - Other background', 'Black - African', 'Black - Caribbean', 'Black - Other background', 'Gypsy, Traveller or Irish Traveller', 'Mixed - White & Asian', 'Mixed - White & Black African', 'Mixed - White & Black Caribbean', 'Mixed - Other background', 'White', 'White - Irish', 'White - Roma', 'White - Other background', 'Other ethnic background', 'I prefer not to say']), hasDisability: z.boolean(), disabilityTypes: z.array(z.enum(['A visual impairment uncorrected by glasses', 'A hearing impairment', 'A mental health condition, challenge, or disorder', 'A learning difficulty', 'A physical impairment, including challenges with mobility or dexterity', 'A long-term illness or health condition that may cause pain, fatigue, loss of concentration, or breathing difficulties – including any effects from related medication', 'A social, behavioural, or communication impairment', 'A development condition since childhood which affects motor, cognitive, social and emotional skills, speech, and language', 'A condition or impairment not listed'])).nullable(), hasBeenInCare: z.boolean().nullable(), careStartDate: z.string().nullable(), careEndDate: z.string().nullable(), careDetails: z.string().nullable(), disabilityTypeOther: z.string().nullable(), lastSchoolDescription: z.string().nullable(), hasParentsInHE: z.boolean().nullable(), isDisabilityStudentAllowance: z.boolean().nullable() })
         * @returns Promise<ApiResponse<UpdateDiversityResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/diversity";
          const bodySchema = z2.object({ occupation: z2.string().nullable(), ethnicity: z2.enum(["Arab", "Asian - Bangladeshi", "Asian - Chinese", "Asian - Indian", "Asian - Pakistani", "Asian - Other background", "Black - African", "Black - Caribbean", "Black - Other background", "Gypsy, Traveller or Irish Traveller", "Mixed - White & Asian", "Mixed - White & Black African", "Mixed - White & Black Caribbean", "Mixed - Other background", "White", "White - Irish", "White - Roma", "White - Other background", "Other ethnic background", "I prefer not to say"]), hasDisability: z2.boolean(), disabilityTypes: z2.array(z2.enum(["A visual impairment uncorrected by glasses", "A hearing impairment", "A mental health condition, challenge, or disorder", "A learning difficulty", "A physical impairment, including challenges with mobility or dexterity", "A long-term illness or health condition that may cause pain, fatigue, loss of concentration, or breathing difficulties \u2013 including any effects from related medication", "A social, behavioural, or communication impairment", "A development condition since childhood which affects motor, cognitive, social and emotional skills, speech, and language", "A condition or impairment not listed"])).nullable(), hasBeenInCare: z2.boolean().nullable(), careStartDate: z2.string().nullable(), careEndDate: z2.string().nullable(), careDetails: z2.string().nullable(), disabilityTypeOther: z2.string().nullable(), lastSchoolDescription: z2.string().nullable(), hasParentsInHE: z2.boolean().nullable(), isDisabilityStudentAllowance: z2.boolean().nullable() });
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/diversity";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Referral: {
        /**
         * GET /apply/applicant/referral
         * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
         * @returns Promise<ApiResponse<GetApplicantReferralResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/applicant/referral";
          const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
          const buildUrl = () => "/apply/applicant/referral";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/applicant/referral
         * @queryParams z.object({ applicationId: z.string() })
         * @body ApplicantReferralSchema
         * @returns Promise<ApiResponse<UpdateApplicantReferralResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/apply/applicant/referral";
          const bodySchema = ApplicantReferralSchema;
          const queryParamsSchema = z2.object({ applicationId: z2.string() });
          const buildUrl = () => "/apply/applicant/referral";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            bodySchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /apply/applicant
       * @queryParams z.object({ attributes: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicantDetailsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/applicant";
        const queryParamsSchema = z2.object({ attributes: z2.string().optional() });
        const buildUrl = () => "/apply/applicant";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ActiveIntakes: {
      /**
       * GET /apply/active-intakes-with-courses/{uni}
       * @pathParams {uni: string}
       * @queryParams z.object({ feeStatus: z.string().optional() })
       * @returns Promise<ApiResponse<GetActiveIntakesWithCoursesResponse | ErrorResponse>>
       */
      withCourses: (() => {
        const method = "GET";
        const path = "/apply/active-intakes-with-courses/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const queryParamsSchema = z2.object({ feeStatus: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/active-intakes-with-courses/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    Config: {
      /**
       * GET /apply/config
       * @queryParams z.object({ uni: z.string() })
       * @returns Promise<ApiResponse<GetApplyConfigResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/config";
        const queryParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = () => "/apply/config";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/config
       * @queryParams z.object({ uni: z.string() })
       * @body z.object({ config: z.object({ privacyPolicyConsentWording: z.object({ subtitle: z.string(), header: z.string(), bodyText: z.string(), buttonLabel: z.string() }), termsAndConditionConsentWording: z.object({ subtitle: z.string(), header: z.string(), bodyText: z.string(), buttonLabel: z.string() }), privacyPolicyUrl: z.string(), termsAndConditionsUrl: z.string(), depositText: z.string().optional(), offerLetterStartTemplate: z.string(), offerLetterEndTemplate: z.string(), scholarships: z.array(z.union([z.object({ type: z.literal('FIXED'), amount: z.number(), name: z.string() }), z.object({ type: z.literal('PERCENTAGE'), percentage: z.number(), name: z.string() })])), welcomeScreen: z.object({ title: z.string(), content: z.string() }), disableFundingTuitionFeeQuestion: z.boolean().optional(), disableFundingMaintenanceQuestion: z.boolean().optional(), disableFundingWorkQuestion: z.boolean().optional(), disableDeclarationInterruptionQuestion: z.boolean().optional(), disableDeclarationConvictionQuestion: z.boolean().optional(), disableDeclarationTask: z.boolean().optional(), rejectionReasons: z.object({ entryCriteriaNotMet: z.string(), failedAcademicAssessment: z.string(), failedCredibilityAssessment: z.string(), fraudulentApplication: z.string(), courseClosure: z.string(), courseFull: z.string(), unableToOfferCourse: z.string(), deadlineHasPassed: z.string(), closedByApplicant: z.string(), wrongApplicationForm: z.string(), failedPreCasInterview: z.string(), failedComplianceInterview: z.string(), negativeQualificationVerification: z.string(), duplicateApplication: z.string(), inactiveApplication: z.string(), regionExclusiveToAgent: z.string(), other: z.string() }).optional(), offerLetterConfig: z.object({ HOME: z.object({ Applied: z.string(), Draft: z.string(), Conditional: z.string(), Unconditional: z.string(), Withdrawn: z.string(), Rejected: z.string(), Completed: z.string() }), OVERSEAS: z.object({ Applied: z.string(), Draft: z.string(), Conditional: z.string(), Unconditional: z.string(), Withdrawn: z.string(), Rejected: z.string(), Completed: z.string() }), NOT_SURE: z.object({ Applied: z.string(), Draft: z.string(), Conditional: z.string(), Unconditional: z.string(), Withdrawn: z.string(), Rejected: z.string(), Completed: z.string() }) }).optional(), customSubdomain: z.string().optional(), sslCertificateArn: z.string().optional(), addressLookupEnabled: z.boolean().optional(), addressLookupConfig: z.object({ permanentAddressLookupEnabled: z.boolean(), contactAddressLookupEnabled: z.boolean(), termAddressLookupEnabled: z.boolean(), ukAddressLookupEnabled: z.boolean(), employmentAddressLookupEnabled: z.boolean(), refereeAddressLookupEnabled: z.boolean(), educationAddressLookupEnabled: z.boolean() }).optional() }) })
       * @returns Promise<ApiResponse<GetApplyConfigResponse | ErrorResponse>>
       */
      update: (() => {
        const method = "PUT";
        const path = "/apply/config";
        const bodySchema = z2.object({ config: z2.object({ privacyPolicyConsentWording: z2.object({ subtitle: z2.string(), header: z2.string(), bodyText: z2.string(), buttonLabel: z2.string() }), termsAndConditionConsentWording: z2.object({ subtitle: z2.string(), header: z2.string(), bodyText: z2.string(), buttonLabel: z2.string() }), privacyPolicyUrl: z2.string(), termsAndConditionsUrl: z2.string(), depositText: z2.string().optional(), offerLetterStartTemplate: z2.string(), offerLetterEndTemplate: z2.string(), scholarships: z2.array(z2.union([z2.object({ type: z2.literal("FIXED"), amount: z2.number(), name: z2.string() }), z2.object({ type: z2.literal("PERCENTAGE"), percentage: z2.number(), name: z2.string() })])), welcomeScreen: z2.object({ title: z2.string(), content: z2.string() }), disableFundingTuitionFeeQuestion: z2.boolean().optional(), disableFundingMaintenanceQuestion: z2.boolean().optional(), disableFundingWorkQuestion: z2.boolean().optional(), disableDeclarationInterruptionQuestion: z2.boolean().optional(), disableDeclarationConvictionQuestion: z2.boolean().optional(), disableDeclarationTask: z2.boolean().optional(), rejectionReasons: z2.object({ entryCriteriaNotMet: z2.string(), failedAcademicAssessment: z2.string(), failedCredibilityAssessment: z2.string(), fraudulentApplication: z2.string(), courseClosure: z2.string(), courseFull: z2.string(), unableToOfferCourse: z2.string(), deadlineHasPassed: z2.string(), closedByApplicant: z2.string(), wrongApplicationForm: z2.string(), failedPreCasInterview: z2.string(), failedComplianceInterview: z2.string(), negativeQualificationVerification: z2.string(), duplicateApplication: z2.string(), inactiveApplication: z2.string(), regionExclusiveToAgent: z2.string(), other: z2.string() }).optional(), offerLetterConfig: z2.object({ HOME: z2.object({ Applied: z2.string(), Draft: z2.string(), Conditional: z2.string(), Unconditional: z2.string(), Withdrawn: z2.string(), Rejected: z2.string(), Completed: z2.string() }), OVERSEAS: z2.object({ Applied: z2.string(), Draft: z2.string(), Conditional: z2.string(), Unconditional: z2.string(), Withdrawn: z2.string(), Rejected: z2.string(), Completed: z2.string() }), NOT_SURE: z2.object({ Applied: z2.string(), Draft: z2.string(), Conditional: z2.string(), Unconditional: z2.string(), Withdrawn: z2.string(), Rejected: z2.string(), Completed: z2.string() }) }).optional(), customSubdomain: z2.string().optional(), sslCertificateArn: z2.string().optional(), addressLookupEnabled: z2.boolean().optional(), addressLookupConfig: z2.object({ permanentAddressLookupEnabled: z2.boolean(), contactAddressLookupEnabled: z2.boolean(), termAddressLookupEnabled: z2.boolean(), ukAddressLookupEnabled: z2.boolean(), employmentAddressLookupEnabled: z2.boolean(), refereeAddressLookupEnabled: z2.boolean(), educationAddressLookupEnabled: z2.boolean() }).optional() }) });
        const queryParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = () => "/apply/config";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/config
       * @returns Promise<ApiResponse<GetApplyConfigResponse | ErrorResponse>>
       */
      create: (() => {
        const method = "POST";
        const path = "/apply/config";
        const buildUrl = () => "/apply/config";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Offers: {
      /**
       * GET /apply/offers
       * @queryParams z.object({ applicationId: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicantOffersResponse | GetErrorResponse>>
       */
      list: (() => {
        const method = "GET";
        const path = "/apply/offers";
        const queryParamsSchema = z2.object({ applicationId: z2.string().optional() });
        const buildUrl = () => "/apply/offers";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/list/offers
       * @queryParams z.object({ intakeId: z.string(), uni: z.string(), page: z.number(), startDate: z.string().optional(), endDate: z.string().optional(), pageSize: z.number().optional(), applicationStage: z.string().optional(), offerStage: z.string(), sortCol: z.string(), sortDir: z.string(), search: z.string(), agentId: z.string().optional(), officeId: z.string().optional(), regionId: z.string().optional(), tagsMatch: z.string().optional(), filters: z.string().optional(), tab: z.string().optional(), idleFrom: z.string().optional(), idleTo: z.string().optional() })
       * @returns Promise<ApiResponse<GetOffersSummaryResponse | GetErrorResponse>>
       */
      listSummary: (() => {
        const method = "GET";
        const path = "/apply/list/offers";
        const queryParamsSchema = z2.object({ intakeId: z2.string(), uni: z2.string(), page: z2.number(), startDate: z2.string().optional(), endDate: z2.string().optional(), pageSize: z2.number().optional(), applicationStage: z2.string().optional(), offerStage: z2.string(), sortCol: z2.string(), sortDir: z2.string(), search: z2.string(), agentId: z2.string().optional(), officeId: z2.string().optional(), regionId: z2.string().optional(), tagsMatch: z2.string().optional(), filters: z2.string().optional(), tab: z2.string().optional(), idleFrom: z2.string().optional(), idleTo: z2.string().optional() });
        const buildUrl = () => "/apply/list/offers";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/list/offers/totals
       * @queryParams z.object({ intakeId: z.string(), uni: z.string(), page: z.number(), startDate: z.string().optional(), endDate: z.string().optional(), pageSize: z.number().optional(), applicationStage: z.string().optional(), offerStage: z.string(), sortCol: z.string(), sortDir: z.string(), search: z.string(), agentId: z.string().optional(), officeId: z.string().optional(), regionId: z.string().optional(), tagsMatch: z.string().optional(), filters: z.string().optional(), tab: z.string().optional(), idleFrom: z.string().optional(), idleTo: z.string().optional() })
       * @returns Promise<ApiResponse<GetOffersStageTotalsResponse | GetErrorResponse>>
       */
      totals: (() => {
        const method = "GET";
        const path = "/apply/list/offers/totals";
        const queryParamsSchema = z2.object({ intakeId: z2.string(), uni: z2.string(), page: z2.number(), startDate: z2.string().optional(), endDate: z2.string().optional(), pageSize: z2.number().optional(), applicationStage: z2.string().optional(), offerStage: z2.string(), sortCol: z2.string(), sortDir: z2.string(), search: z2.string(), agentId: z2.string().optional(), officeId: z2.string().optional(), regionId: z2.string().optional(), tagsMatch: z2.string().optional(), filters: z2.string().optional(), tab: z2.string().optional(), idleFrom: z2.string().optional(), idleTo: z2.string().optional() });
        const buildUrl = () => "/apply/list/offers/totals";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    Uni: {
      Applications: {
        /**
         * GET /apply/list/applications
         * @queryParams z.object({ intakeId: z.string(), uni: z.string(), page: z.number(), startDate: z.string().optional(), endDate: z.string().optional(), pageSize: z.number().optional(), applicationStage: z.string(), offerStage: z.string().optional(), sortCol: z.string(), sortDir: z.string(), search: z.string(), agentId: z.string().optional(), officeId: z.string().optional(), regionId: z.string().optional(), tagsMatch: z.string().optional(), filters: z.string().optional(), tab: z.string().optional(), idleFrom: z.string().optional(), idleTo: z.string().optional() })
         * @returns Promise<ApiResponse<GetApplicationsSummaryResponse | GetErrorResponse>>
         */
        list: (() => {
          const method = "GET";
          const path = "/apply/list/applications";
          const queryParamsSchema = z2.object({ intakeId: z2.string(), uni: z2.string(), page: z2.number(), startDate: z2.string().optional(), endDate: z2.string().optional(), pageSize: z2.number().optional(), applicationStage: z2.string(), offerStage: z2.string().optional(), sortCol: z2.string(), sortDir: z2.string(), search: z2.string(), agentId: z2.string().optional(), officeId: z2.string().optional(), regionId: z2.string().optional(), tagsMatch: z2.string().optional(), filters: z2.string().optional(), tab: z2.string().optional(), idleFrom: z2.string().optional(), idleTo: z2.string().optional() });
          const buildUrl = () => "/apply/list/applications";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /apply/list/applications/totals
         * @queryParams z.object({ intakeId: z.string(), uni: z.string(), page: z.number(), startDate: z.string().optional(), endDate: z.string().optional(), pageSize: z.number().optional(), applicationStage: z.string(), offerStage: z.string().optional(), sortCol: z.string(), sortDir: z.string(), search: z.string(), agentId: z.string().optional(), officeId: z.string().optional(), regionId: z.string().optional(), tagsMatch: z.string().optional(), filters: z.string().optional(), tab: z.string().optional(), idleFrom: z.string().optional(), idleTo: z.string().optional() })
         * @returns Promise<ApiResponse<GetApplicationsStageTotalsResponse | GetErrorResponse>>
         */
        totals: (() => {
          const method = "GET";
          const path = "/apply/list/applications/totals";
          const queryParamsSchema = z2.object({ intakeId: z2.string(), uni: z2.string(), page: z2.number(), startDate: z2.string().optional(), endDate: z2.string().optional(), pageSize: z2.number().optional(), applicationStage: z2.string(), offerStage: z2.string().optional(), sortCol: z2.string(), sortDir: z2.string(), search: z2.string(), agentId: z2.string().optional(), officeId: z2.string().optional(), regionId: z2.string().optional(), tagsMatch: z2.string().optional(), filters: z2.string().optional(), tab: z2.string().optional(), idleFrom: z2.string().optional(), idleTo: z2.string().optional() });
          const buildUrl = () => "/apply/list/applications/totals";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            queryParamsSchema,
            buildUrl
          });
        })()
      },
      Application: {
        ApplicantDetails: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/application/{applicationId}/applicant-details
           * @pathParams {uni: string, applicantId: string, applicationId: string}
           * @body ApplicantDetailsSchema
           * @returns Promise<ApiResponse<unknown>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/applicant-details";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
            const bodySchema = ApplicantDetailsSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/applicant-details";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Courses: {
          /**
           * GET /apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses
           * @pathParams {uni: string, applicantId: string, applicationId: string}
           * @queryParams z.object({ intakeId: z.string().optional() })
           * @returns Promise<ApiResponse<staffGetCoursesResponse | ErrorResponse>>
           */
          list: (() => {
            const method = "GET";
            const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
            const queryParamsSchema = z2.object({ intakeId: z2.string().optional() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              queryParamsSchema,
              buildUrl
            });
          })(),
          /**
           * GET /apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses/change
           * @pathParams {uni: string, applicantId: string, applicationId: string}
           * @queryParams z.object({ intakeId: z.string(), courseId: z.string() })
           * @returns Promise<ApiResponse<staffGetCourseChangeResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "GET";
            const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses/change";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
            const queryParamsSchema = z2.object({ intakeId: z2.string(), courseId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/courses/change";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              queryParamsSchema,
              buildUrl
            });
          })()
        },
        /**
         * GET /apply/{uni}/applicant/{applicantId}/application/{applicationId}
         * @pathParams {uni: string, applicantId: string, applicationId: string}
         * @queryParams z.object({ mock: z.string().optional() })
         * @returns Promise<ApiResponse<GetStaffApplicationResponse | ErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
          const queryParamsSchema = z2.object({ mock: z2.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /apply/{uni}/applicant/{applicantId}/application/{applicationId}/audit-log
         * @pathParams {uni: string, applicantId: string, applicationId: string}
         * @returns Promise<ApiResponse<GetApplyAuditLogResponse | ErrorResponse>>
         */
        auditLog: (() => {
          const method = "GET";
          const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/audit-log";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/audit-log";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /apply/{uni}/applicant/{applicantId}/application/{applicationId}/offer/{offerId}/offer-timeline
         * @pathParams {uni: string, applicantId: string, applicationId: string, offerId: string}
         * @returns Promise<ApiResponse<GetOfferTimelineResponse | ErrorResponse>>
         */
        offerTimeline: (() => {
          const method = "GET";
          const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/offer/{offerId}/offer-timeline";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/offer/{offerId}/offer-timeline";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /apply/{uni}/applicant/{applicantId}/emails
         * @pathParams {uni: string, applicantId: string}
         * @returns Promise<ApiResponse<GetApplyEmailsResponse | ErrorResponse>>
         */
        emails: (() => {
          const method = "GET";
          const path = "/apply/{uni}/applicant/{applicantId}/emails";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/emails";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Offer: {
        LetterText: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/letter-text
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body UpdateApplicantOfferLetterTextSchema
           * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/letter-text";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = UpdateApplicantOfferLetterTextSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/letter-text";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        ProgrammeDetails: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/programme-details
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body UpdateApplicantOfferProgrammeDetailsSchema
           * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/programme-details";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = UpdateApplicantOfferProgrammeDetailsSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/programme-details";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Requirements: {
          Academic: {
            Studies: {
              /**
               * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/academic/studies
               * @pathParams {uni: string, applicantId: string, offerId: string}
               * @body z.object({ qualificationEntryId: z.string(), studyIds: z.array(z.string()) })
               * @returns Promise<ApiResponse<IApplicantOfferAcademicRequirement | ErrorResponse>>
               */
              update: (() => {
                const method = "PUT";
                const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/academic/studies";
                const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
                const bodySchema = z2.object({ qualificationEntryId: z2.string(), studyIds: z2.array(z2.string()) });
                const buildUrl = (params) => {
                  try {
                    const validated = pathParamsSchema.parse(params);
                    let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/academic/studies";
                    url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                    url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                    url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                    return url;
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "path parameters");
                      console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                const fn = async (args) => {
                  let url = buildUrl(args.pathParams);
                  if (args.queryParams) {
                    const queryString = buildQueryString(args.queryParams);
                    if (queryString) url += "?" + queryString;
                  }
                  try {
                    const validatedBody = bodySchema.parse(args.body);
                    return makeRequest(method, url, validatedBody, args.options);
                  } catch (error) {
                    if (error instanceof z2.ZodError) {
                      const formatted = formatZodError(error, "request body");
                      console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                      throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                    }
                    throw error;
                  }
                };
                return Object.assign(fn, {
                  method,
                  path,
                  pathParamsSchema,
                  bodySchema,
                  buildUrl
                });
              })()
            }
          },
          /**
           * POST /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body CreateApplicantOfferRequirementTasksSchema
           * @returns Promise<ApiResponse<CreateApplicantOfferRequirementTaskResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = CreateApplicantOfferRequirementTasksSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Requirement: {
          InternalData: {
            /**
             * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/internal-data
             * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
             * @body InternalDocumentSchema
             * @returns Promise<ApiResponse<UpdateOfferRequirementInternalDataResponse | ErrorResponse>>
             */
            update: (() => {
              const method = "PUT";
              const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/internal-data";
              const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string(), requirementId: z2.string() });
              const bodySchema = InternalDocumentSchema;
              const buildUrl = (params) => {
                try {
                  const validated = pathParamsSchema.parse(params);
                  let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/internal-data";
                  url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                  url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                  url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                  url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                  return url;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "path parameters");
                    console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              const fn = async (args) => {
                let url = buildUrl(args.pathParams);
                if (args.queryParams) {
                  const queryString = buildQueryString(args.queryParams);
                  if (queryString) url += "?" + queryString;
                }
                try {
                  const validatedBody = bodySchema.parse(args.body);
                  return makeRequest(method, url, validatedBody, args.options);
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "request body");
                    console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              };
              return Object.assign(fn, {
                method,
                path,
                pathParamsSchema,
                bodySchema,
                buildUrl
              });
            })()
          },
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/status
           * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
           * @body UpdateApplicantOfferRequirementTaskStatusSchema
           * @returns Promise<ApiResponse<IApplicantOfferRequirementTask | ErrorResponse>>
           */
          status: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/status";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string(), requirementId: z2.string() });
            const bodySchema = UpdateApplicantOfferRequirementTaskStatusSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/status";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/level
           * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
           * @body UpdateApplicantOfferRequirementTaskLevelSchema
           * @returns Promise<ApiResponse<IApplicantOfferRequirementTask | ErrorResponse>>
           */
          level: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/level";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string(), requirementId: z2.string() });
            const bodySchema = UpdateApplicantOfferRequirementTaskLevelSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/level";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/exempt
           * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
           * @body ExemptApplicantOfferRequirementSchema
           * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
           */
          exempt: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/exempt";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string(), requirementId: z2.string() });
            const bodySchema = ExemptApplicantOfferRequirementSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/exempt";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Deposit: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/deposit/status
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body UpdateApplicantOfferPayment
           * @returns Promise<ApiResponse<IApplicantOfferPayment | ErrorResponse>>
           */
          status: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/deposit/status";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = UpdateApplicantOfferPayment;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/deposit/status";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        PaymentProof: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment-proof/status
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body UpdateApplicantOfferPayment
           * @returns Promise<ApiResponse<IApplicantOfferPayment | ErrorResponse>>
           */
          status: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment-proof/status";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = UpdateApplicantOfferPayment;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment-proof/status";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Payment: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment/exempt
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @body ExemptApplicantOfferRequirementSchema
           * @returns Promise<ApiResponse<IApplicantOfferPayment | ErrorResponse>>
           */
          exempt: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment/exempt";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const bodySchema = ExemptApplicantOfferRequirementSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/payment/exempt";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Tags: {
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/pin
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          pin: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/pin";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/pin";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/unpin
           * @pathParams {uni: string, applicantId: string, offerId: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          unpin: (() => {
            const method = "PUT";
            const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/unpin";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/tags/unpin";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        /**
         * GET /apply/{uni}/applicant/{applicantId}/offers/{offerId}
         * @pathParams {uni: string, applicantId: string, offerId: string}
         * @returns Promise<ApiResponse<StaffGetApplicantOfferResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/{uni}/applicant/{applicantId}/application/{applicationId}/offers
         * @pathParams {uni: string, applicantId: string, applicationId: string}
         * @body StaffCreateApplicantOfferSchema
         * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
         */
        create: (() => {
          const method = "POST";
          const path = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/offers";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
          const bodySchema = StaffCreateApplicantOfferSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/application/{applicationId}/offers";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}
         * @pathParams {uni: string, applicantId: string, offerId: string}
         * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/status
         * @pathParams {uni: string, applicantId: string, offerId: string}
         * @body UpdateApplicantOfferStatusSchema
         * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
         */
        status: (() => {
          const method = "PUT";
          const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/status";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
          const bodySchema = UpdateApplicantOfferStatusSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/{uni}/applicant/{applicantId}/offers/{offerId}/reinstate
         * @pathParams {uni: string, applicantId: string, offerId: string}
         * @body ReinstateApplicantOfferSchema
         * @returns Promise<ApiResponse<void | ErrorResponse>>
         */
        reinstate: (() => {
          const method = "PUT";
          const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/reinstate";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
          const bodySchema = ReinstateApplicantOfferSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/reinstate";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/{uni}/applicant/{applicantId}/offers/{offerId}/request-tasks
         * @pathParams {uni: string, applicantId: string, offerId: string}
         * @body z.object({ level: z.enum(['PreOffer', 'PreEnrolment']) })
         * @returns Promise<ApiResponse<IApplicantOffer | ErrorResponse>>
         */
        requestTasks: (() => {
          const method = "POST";
          const path = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/request-tasks";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), offerId: z2.string() });
          const bodySchema = z2.object({ level: z2.enum(["PreOffer", "PreEnrolment"]) });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/offers/{offerId}/request-tasks";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Applicant: {
        /**
         * DELETE /apply/{uni}/applicant/{applicantId}/unlink-email
         * @pathParams {uni: string, applicantId: string}
         * @returns Promise<ApiResponse<{ message: string } | ErrorResponse>>
         */
        unlinkEmail: (() => {
          const method = "DELETE";
          const path = "/apply/{uni}/applicant/{applicantId}/unlink-email";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/{uni}/applicant/{applicantId}/unlink-email";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /apply/uni-list
       * @returns Promise<ApiResponse<UniListResponse>>
       */
      list: (() => {
        const method = "GET";
        const path = "/apply/uni-list";
        const buildUrl = () => "/apply/uni-list";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Offer: {
      Requirement: {
        Completions: {
          /**
           * GET /apply/offers/{offerId}/requirements/completions
           * @pathParams {offerId: string}
           * @returns Promise<ApiResponse<RequirementCompletionsResponse | ErrorResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/apply/offers/{offerId}/requirements/completions";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/completions";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        Payment: {
          /**
           * GET /apply/offers/{offerId}/requirements/payment
           * @pathParams {offerId: string}
           * @queryParams z.object({ getPaymentDoc: z.boolean() })
           * @returns Promise<ApiResponse<GetApplicantOfferPaymentRequirementResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/apply/offers/{offerId}/requirements/payment";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const queryParamsSchema = z2.object({ getPaymentDoc: z2.boolean() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/payment";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                try {
                  const validatedQuery = queryParamsSchema.parse(args.queryParams);
                  const queryString = buildQueryString(validatedQuery);
                  if (queryString) url += "?" + queryString;
                } catch (error) {
                  if (error instanceof z2.ZodError) {
                    const formatted = formatZodError(error, "query parameters");
                    console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                    throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                  }
                  throw error;
                }
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              queryParamsSchema,
              buildUrl
            });
          })(),
          /**
           * PUT /apply/offers/{offerId}/requirements/payment
           * @pathParams {offerId: string}
           * @body z.object({ paymentMethod: z.enum(['Deposit', 'Sponsorship', 'SLCFunding']), statusInternalNote: z.string().nullable().optional(), depositDetail: z.object({ depositAmount: z.number(), paymentDate: z.string() }).nullable().optional(), sponsorshipDetail: z.object({ sponsorType: z.enum(['UkGovernment', 'BritishCouncil', 'YourGovernment', 'InternationalOrganisation', 'InternationalCompany']), sponsorName: z.string(), isSponsorOrgMultinational: z.boolean().nullable().optional() }), slcDetail: z.object({ customerRefNumber: z.string(), studentSupportNumber: z.string() }).nullable().optional() })
           * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/offers/{offerId}/requirements/payment";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const bodySchema = z2.object({ paymentMethod: z2.enum(["Deposit", "Sponsorship", "SLCFunding"]), statusInternalNote: z2.string().nullable().optional(), depositDetail: z2.object({ depositAmount: z2.number(), paymentDate: z2.string() }).nullable().optional(), sponsorshipDetail: z2.object({ sponsorType: z2.enum(["UkGovernment", "BritishCouncil", "YourGovernment", "InternationalOrganisation", "InternationalCompany"]), sponsorName: z2.string(), isSponsorOrgMultinational: z2.boolean().nullable().optional() }), slcDetail: z2.object({ customerRefNumber: z2.string(), studentSupportNumber: z2.string() }).nullable().optional() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/payment";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        CalendlyInterview: {
          /**
           * POST /apply/offers/{offerId}/requirements/{requirementId}/booking-requested
           * @pathParams {offerId: string, requirementId: string}
           * @returns Promise<ApiResponse<MarkBookingRequestedResponse | ErrorResponse>>
           */
          bookingRequested: (() => {
            const method = "POST";
            const path = "/apply/offers/{offerId}/requirements/{requirementId}/booking-requested";
            const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/{requirementId}/booking-requested";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        RecordedInterview: {
          /**
           * POST /apply/offers/{offerId}/requirements/{requirementId}/recorded-interview
           * @pathParams {offerId: string, requirementId: string}
           * @body z.object({ videoId: z.string().optional(), questions: z.string(), welcomeTitle: z.string().optional(), attemptIndex: z.number(), exceeded: z.boolean().optional() })
           * @returns Promise<ApiResponse<RecordedInterviewResponse | ErrorResponse>>
           */
          attempt: (() => {
            const method = "POST";
            const path = "/apply/offers/{offerId}/requirements/{requirementId}/recorded-interview";
            const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
            const bodySchema = z2.object({ videoId: z2.string().optional(), questions: z2.string(), welcomeTitle: z2.string().optional(), attemptIndex: z2.number(), exceeded: z2.boolean().optional() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/{requirementId}/recorded-interview";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        Passport: {
          /**
           * PUT /apply/offers/{offerId}/requirements/passport
           * @pathParams {offerId: string}
           * @body OfferPassportSchema
           * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/offers/{offerId}/requirements/passport";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const bodySchema = OfferPassportSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/passport";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        EnglishLanguageResults: {
          /**
           * PUT /apply/offers/{offerId}/requirements/english-language-results
           * @pathParams {offerId: string}
           * @body EnglishResultsFulfilmentSchema
           * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/offers/{offerId}/requirements/english-language-results";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const bodySchema = EnglishResultsFulfilmentSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/english-language-results";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        RefereeDetails: {
          /**
           * PUT /apply/offers/{offerId}/requirements/referee-details
           * @pathParams {offerId: string}
           * @body RefereeDetailsFulfilmentSchema
           * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
           */
          update: (() => {
            const method = "PUT";
            const path = "/apply/offers/{offerId}/requirements/referee-details";
            const pathParamsSchema = z2.object({ offerId: z2.string() });
            const bodySchema = RefereeDetailsFulfilmentSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/apply/offers/{offerId}/requirements/referee-details";
                url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        /**
         * GET /apply/offers/{offerId}/requirements/{requirementId}
         * @pathParams {offerId: string, requirementId: string}
         * @returns Promise<ApiResponse<GetOfferRequirementTaskResponse | ErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/offers/{offerId}/requirements/{requirementId}";
          const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/requirements/{requirementId}";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /apply/offers/{offerId}/requirements/{requirementId}/prefill
         * @pathParams {offerId: string, requirementId: string}
         * @body z.object({ sourceOfferId: z.string() })
         * @returns Promise<ApiResponse<GetOfferRequirementTaskResponse | ErrorResponse>>
         */
        prefill: (() => {
          const method = "POST";
          const path = "/apply/offers/{offerId}/requirements/{requirementId}/prefill";
          const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
          const bodySchema = z2.object({ sourceOfferId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/requirements/{requirementId}/prefill";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/offers/{offerId}/requirements/{requirementId}/dismiss-completion
         * @pathParams {offerId: string, requirementId: string}
         * @returns Promise<ApiResponse<{ success: boolean } | ErrorResponse>>
         */
        dismissCompletion: (() => {
          const method = "PUT";
          const path = "/apply/offers/{offerId}/requirements/{requirementId}/dismiss-completion";
          const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/requirements/{requirementId}/dismiss-completion";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/offers/{offerId}/requirements/{requirementId}
         * @pathParams {offerId: string, requirementId: string}
         * @body DocumentFulfilmentSchema
         * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/apply/offers/{offerId}/requirements/{requirementId}";
          const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
          const bodySchema = DocumentFulfilmentSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/requirements/{requirementId}";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      ApplicationStatus: {
        /**
         * PUT /apply/offers/{offerId}/applicantStatus
         * @pathParams {offerId: string}
         * @body UpdateApplicantOfferStatusActionSchema
         * @returns Promise<ApiResponse<IUpdateOfferApplicantStatus | ErrorResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/apply/offers/{offerId}/applicantStatus";
          const pathParamsSchema = z2.object({ offerId: z2.string() });
          const bodySchema = UpdateApplicantOfferStatusActionSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/applicantStatus";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Payment: {
        /**
         * GET /apply/offers/{offerId}/payment
         * @pathParams {offerId: string}
         * @queryParams z.object({ getPaymentDoc: z.boolean() })
         * @returns Promise<ApiResponse<GetApplicantOfferPaymentResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/offers/{offerId}/payment";
          const pathParamsSchema = z2.object({ offerId: z2.string() });
          const queryParamsSchema = z2.object({ getPaymentDoc: z2.boolean() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/payment";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            queryParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/offers/{offerId}/payment
         * @pathParams {offerId: string}
         * @body z.object({ paymentMethod: z.enum(['Deposit', 'Sponsorship', 'SLCFunding']), status: z.enum(['Request', 'Review', 'Exempt', 'Approved']).nullable().optional(), proofOfPayment: z.object({ fileName: z.string().nullable(), s3Keys: z.array(z.string()).nullable(), sKey: z.string().nullable(), status: z.enum(['Request', 'Review', 'Exempt', 'Approved']).nullable().optional(), urls: z.array(z.string()).optional(), statusInternalNote: z.string().nullable().optional() }), statusInternalNote: z.string().nullable().optional(), depositDetail: z.object({ depositAmount: z.number(), paymentDate: z.string() }).nullable().optional(), sponsorshipDetail: z.object({ sponsorType: z.enum(['UkGovernment', 'BritishCouncil', 'YourGovernment', 'InternationalOrganisation', 'InternationalCompany']), sponsorName: z.string(), isSponsorOrgMultinational: z.boolean().nullable().optional() }), slcDetail: z.object({ customerRefNumber: z.string(), studentSupportNumber: z.string() }).nullable().optional() })
         * @returns Promise<ApiResponse<IUpdateApplicantOfferPaymentResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/apply/offers/{offerId}/payment";
          const pathParamsSchema = z2.object({ offerId: z2.string() });
          const bodySchema = z2.object({ paymentMethod: z2.enum(["Deposit", "Sponsorship", "SLCFunding"]), status: z2.enum(["Request", "Review", "Exempt", "Approved"]).nullable().optional(), proofOfPayment: z2.object({ fileName: z2.string().nullable(), s3Keys: z2.array(z2.string()).nullable(), sKey: z2.string().nullable(), status: z2.enum(["Request", "Review", "Exempt", "Approved"]).nullable().optional(), urls: z2.array(z2.string()).optional(), statusInternalNote: z2.string().nullable().optional() }), statusInternalNote: z2.string().nullable().optional(), depositDetail: z2.object({ depositAmount: z2.number(), paymentDate: z2.string() }).nullable().optional(), sponsorshipDetail: z2.object({ sponsorType: z2.enum(["UkGovernment", "BritishCouncil", "YourGovernment", "InternationalOrganisation", "InternationalCompany"]), sponsorName: z2.string(), isSponsorOrgMultinational: z2.boolean().nullable().optional() }), slcDetail: z2.object({ customerRefNumber: z2.string(), studentSupportNumber: z2.string() }).nullable().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/payment";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      PaymentProof: {
        /**
         * GET /apply/offers/{offerId}/proof-of-payment
         * @pathParams {offerId: string}
         * @returns Promise<ApiResponse<GetOfferProofOfPaymentResponse | ErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/apply/offers/{offerId}/proof-of-payment";
          const pathParamsSchema = z2.object({ offerId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/proof-of-payment";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /apply/offers/{offerId}/proof-of-payment
         * @pathParams {offerId: string}
         * @body ProofOfPaymentSchema
         * @returns Promise<ApiResponse<IUpdateOfferProofOfPaymentResponse | ErrorResponse>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/apply/offers/{offerId}/proof-of-payment";
          const pathParamsSchema = z2.object({ offerId: z2.string() });
          const bodySchema = ProofOfPaymentSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/apply/offers/{offerId}/proof-of-payment";
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /apply/offers/{offerId}
       * @pathParams {offerId: string}
       * @queryParams z.object({ noRequirements: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicantOfferResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/offers/{offerId}";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const queryParamsSchema = z2.object({ noRequirements: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/offers/{offerId}";
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    Courses: {
      /**
       * GET /apply/list/course
       * @queryParams z.object({ uni: z.string(), intakeId: z.string(), startDate: z.string(), endDate: z.string(), agentId: z.string(), officeId: z.string(), currentUserRegionId: z.string() })
       * @returns Promise<ApiResponse<IGetAllApplyCourseResponse | ErrorResponse>>
       */
      list: (() => {
        const method = "GET";
        const path = "/apply/list/course";
        const queryParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string(), startDate: z2.string(), endDate: z2.string(), agentId: z2.string(), officeId: z2.string(), currentUserRegionId: z2.string() });
        const buildUrl = () => "/apply/list/course";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/course/{uni}/{intakeId}
       * @pathParams {uni: string, intakeId: string}
       * @queryParams z.object({ page: z.string(), limit: z.string(), searchOn: z.enum(['id', 'name', 'shortName', 'hecos', 'campus', 'faculty', 'department', 'award', 'UCASApplyCode', 'UCASFacultyCode']).optional(), searchValue: z.string().optional() })
       * @returns Promise<ApiResponse<ListApplyCoursesResponse>>
       */
      listByUniAndIntakeId: (() => {
        const method = "GET";
        const path = "/apply/course/{uni}/{intakeId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string() });
        const queryParamsSchema = z2.object({ page: z2.string(), limit: z2.string(), searchOn: z2.enum(["id", "name", "shortName", "hecos", "campus", "faculty", "department", "award", "UCASApplyCode", "UCASFacultyCode"]).optional(), searchValue: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/course/{uni}/{intakeId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    Course: {
      /**
       * POST /apply/course/{uni}/{intakeId}
       * @pathParams {uni: string, intakeId: string}
       * @body z.object({ s_key: z.string(), id: z.string(), uni: z.string(), shortId: z.string(), intakeId: z.string(), mode: z.enum(['Full-time', 'Part-time', 'Mixed-mode', 'Sandwich', 'Distance-learning']), externalId: z.string(), name: z.string(), shortName: z.string(), award: z.string(), rqfLevel: z.enum(['1', '2', '3', '4', '5', '6', '7', '8']), level: z.enum(['Foundation', 'Undergraduate', 'Postgraduate', 'Research']), awardingBody: z.string().optional(), duration: z.number(), entryPoint: z.enum(['Year 0', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6']), category: z.string().optional(), campus: z.string(), faculty: z.string(), department: z.string().optional(), isHTQ: z.boolean(), UCASApplyCode: z.string().optional(), UCASFacultyCode: z.string().optional(), availableHome: z.boolean(), availableOverseas: z.boolean(), feeHome: z.number().optional(), feeHomeTotal: z.number().optional(), feeOverseas: z.number().optional(), feeOverseasTotal: z.number().optional(), startMonthHome: z.string().optional(), startDateHome: z.string().optional(), endDateHome: z.string().optional(), startMonthOverseas: z.string().optional(), startDateOverseas: z.string().optional(), endDateOverseas: z.string().optional(), lastAcceptanceDate: z.string().optional(), hecos: z.array(z.object({ code: z.string(), name: z.string(), percentage: z.number() })).optional(), academicRequirements: z.object({ HOME: z.union([z.object({ name: z.string(), academicRequirementId: z.string().optional() }), z.array(z.object({ id: z.string(), name: z.string(), taskTextOverrides: z.object({}).optional(), conditionTextOverrides: z.object({}).optional() }))]), OVERSEAS: z.union([z.object({ name: z.string(), academicRequirementId: z.string().optional() }), z.array(z.object({ id: z.string(), name: z.string(), taskTextOverrides: z.object({}).optional(), conditionTextOverrides: z.object({}).optional() }))]) }), languageRequirements: z.object({ HOME: z.object({ name: z.string(), languageRequirementId: z.string().optional() }), OVERSEAS: z.object({ name: z.string(), languageRequirementId: z.string().optional() }) }), requirements: z.object({}), availability: z.object({ type: z.enum(['all', 'limited_partners']), allowedPartners: z.array(z.string()).optional() }), applicationTasks: z.object({ EnglishLanguage: z.boolean(), Employment: z.boolean(), References: z.boolean(), PersonalStatement: z.boolean(), ResearchProposal: z.boolean(), Funding: z.boolean(), ImmigrationHistory: z.boolean(), DiversityInclusion: z.boolean(), Representation: z.boolean(), Referral: z.boolean(), Declarations: z.boolean() }).optional() })
       * @returns Promise<ApiResponse<any>>
       */
      create: (() => {
        const method = "POST";
        const path = "/apply/course/{uni}/{intakeId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string() });
        const bodySchema = z2.object({ s_key: z2.string(), id: z2.string(), uni: z2.string(), shortId: z2.string(), intakeId: z2.string(), mode: z2.enum(["Full-time", "Part-time", "Mixed-mode", "Sandwich", "Distance-learning"]), externalId: z2.string(), name: z2.string(), shortName: z2.string(), award: z2.string(), rqfLevel: z2.enum(["1", "2", "3", "4", "5", "6", "7", "8"]), level: z2.enum(["Foundation", "Undergraduate", "Postgraduate", "Research"]), awardingBody: z2.string().optional(), duration: z2.number(), entryPoint: z2.enum(["Year 0", "Year 1", "Year 2", "Year 3", "Year 4", "Year 5", "Year 6"]), category: z2.string().optional(), campus: z2.string(), faculty: z2.string(), department: z2.string().optional(), isHTQ: z2.boolean(), UCASApplyCode: z2.string().optional(), UCASFacultyCode: z2.string().optional(), availableHome: z2.boolean(), availableOverseas: z2.boolean(), feeHome: z2.number().optional(), feeHomeTotal: z2.number().optional(), feeOverseas: z2.number().optional(), feeOverseasTotal: z2.number().optional(), startMonthHome: z2.string().optional(), startDateHome: z2.string().optional(), endDateHome: z2.string().optional(), startMonthOverseas: z2.string().optional(), startDateOverseas: z2.string().optional(), endDateOverseas: z2.string().optional(), lastAcceptanceDate: z2.string().optional(), hecos: z2.array(z2.object({ code: z2.string(), name: z2.string(), percentage: z2.number() })).optional(), academicRequirements: z2.object({ HOME: z2.union([z2.object({ name: z2.string(), academicRequirementId: z2.string().optional() }), z2.array(z2.object({ id: z2.string(), name: z2.string(), taskTextOverrides: z2.object({}).optional(), conditionTextOverrides: z2.object({}).optional() }))]), OVERSEAS: z2.union([z2.object({ name: z2.string(), academicRequirementId: z2.string().optional() }), z2.array(z2.object({ id: z2.string(), name: z2.string(), taskTextOverrides: z2.object({}).optional(), conditionTextOverrides: z2.object({}).optional() }))]) }), languageRequirements: z2.object({ HOME: z2.object({ name: z2.string(), languageRequirementId: z2.string().optional() }), OVERSEAS: z2.object({ name: z2.string(), languageRequirementId: z2.string().optional() }) }), requirements: z2.object({}), availability: z2.object({ type: z2.enum(["all", "limited_partners"]), allowedPartners: z2.array(z2.string()).optional() }), applicationTasks: z2.object({ EnglishLanguage: z2.boolean(), Employment: z2.boolean(), References: z2.boolean(), PersonalStatement: z2.boolean(), ResearchProposal: z2.boolean(), Funding: z2.boolean(), ImmigrationHistory: z2.boolean(), DiversityInclusion: z2.boolean(), Representation: z2.boolean(), Referral: z2.boolean(), Declarations: z2.boolean() }).optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/course/{uni}/{intakeId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/course/{uni}/{intakeId}/{id}
       * @pathParams {uni: string, intakeId: string, id: string}
       * @returns Promise<ApiResponse<IApplyCourse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/course/{uni}/{intakeId}/{id}";
        const pathParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string(), id: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/course/{uni}/{intakeId}/{id}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
            url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/course/{uni}/{intakeId}/{id}
       * @pathParams {uni: string, intakeId: string, id: string}
       * @body z.object({ s_key: z.string(), id: z.string(), uni: z.string(), shortId: z.string(), intakeId: z.string(), mode: z.enum(['Full-time', 'Part-time', 'Mixed-mode', 'Sandwich', 'Distance-learning']), externalId: z.string(), name: z.string(), shortName: z.string(), award: z.string(), rqfLevel: z.enum(['1', '2', '3', '4', '5', '6', '7', '8']), level: z.enum(['Foundation', 'Undergraduate', 'Postgraduate', 'Research']), awardingBody: z.string().optional(), duration: z.number(), entryPoint: z.enum(['Year 0', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6']), category: z.string().optional(), campus: z.string(), faculty: z.string(), department: z.string().optional(), isHTQ: z.boolean(), UCASApplyCode: z.string().optional(), UCASFacultyCode: z.string().optional(), availableHome: z.boolean(), availableOverseas: z.boolean(), feeHome: z.number().optional(), feeHomeTotal: z.number().optional(), feeOverseas: z.number().optional(), feeOverseasTotal: z.number().optional(), startMonthHome: z.string().optional(), startDateHome: z.string().optional(), endDateHome: z.string().optional(), startMonthOverseas: z.string().optional(), startDateOverseas: z.string().optional(), endDateOverseas: z.string().optional(), lastAcceptanceDate: z.string().optional(), hecos: z.array(z.object({ code: z.string(), name: z.string(), percentage: z.number() })).optional(), academicRequirements: z.object({ HOME: z.union([z.object({ name: z.string(), academicRequirementId: z.string().optional() }), z.array(z.object({ id: z.string(), name: z.string(), taskTextOverrides: z.object({}).optional(), conditionTextOverrides: z.object({}).optional() }))]), OVERSEAS: z.union([z.object({ name: z.string(), academicRequirementId: z.string().optional() }), z.array(z.object({ id: z.string(), name: z.string(), taskTextOverrides: z.object({}).optional(), conditionTextOverrides: z.object({}).optional() }))]) }), languageRequirements: z.object({ HOME: z.object({ name: z.string(), languageRequirementId: z.string().optional() }), OVERSEAS: z.object({ name: z.string(), languageRequirementId: z.string().optional() }) }), requirements: z.object({}), availability: z.object({ type: z.enum(['all', 'limited_partners']), allowedPartners: z.array(z.string()).optional() }), applicationTasks: z.object({ EnglishLanguage: z.boolean(), Employment: z.boolean(), References: z.boolean(), PersonalStatement: z.boolean(), ResearchProposal: z.boolean(), Funding: z.boolean(), ImmigrationHistory: z.boolean(), DiversityInclusion: z.boolean(), Representation: z.boolean(), Referral: z.boolean(), Declarations: z.boolean() }).optional() })
       * @returns Promise<ApiResponse<IApplyCourse>>
       */
      update: (() => {
        const method = "PUT";
        const path = "/apply/course/{uni}/{intakeId}/{id}";
        const pathParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string(), id: z2.string() });
        const bodySchema = z2.object({ s_key: z2.string(), id: z2.string(), uni: z2.string(), shortId: z2.string(), intakeId: z2.string(), mode: z2.enum(["Full-time", "Part-time", "Mixed-mode", "Sandwich", "Distance-learning"]), externalId: z2.string(), name: z2.string(), shortName: z2.string(), award: z2.string(), rqfLevel: z2.enum(["1", "2", "3", "4", "5", "6", "7", "8"]), level: z2.enum(["Foundation", "Undergraduate", "Postgraduate", "Research"]), awardingBody: z2.string().optional(), duration: z2.number(), entryPoint: z2.enum(["Year 0", "Year 1", "Year 2", "Year 3", "Year 4", "Year 5", "Year 6"]), category: z2.string().optional(), campus: z2.string(), faculty: z2.string(), department: z2.string().optional(), isHTQ: z2.boolean(), UCASApplyCode: z2.string().optional(), UCASFacultyCode: z2.string().optional(), availableHome: z2.boolean(), availableOverseas: z2.boolean(), feeHome: z2.number().optional(), feeHomeTotal: z2.number().optional(), feeOverseas: z2.number().optional(), feeOverseasTotal: z2.number().optional(), startMonthHome: z2.string().optional(), startDateHome: z2.string().optional(), endDateHome: z2.string().optional(), startMonthOverseas: z2.string().optional(), startDateOverseas: z2.string().optional(), endDateOverseas: z2.string().optional(), lastAcceptanceDate: z2.string().optional(), hecos: z2.array(z2.object({ code: z2.string(), name: z2.string(), percentage: z2.number() })).optional(), academicRequirements: z2.object({ HOME: z2.union([z2.object({ name: z2.string(), academicRequirementId: z2.string().optional() }), z2.array(z2.object({ id: z2.string(), name: z2.string(), taskTextOverrides: z2.object({}).optional(), conditionTextOverrides: z2.object({}).optional() }))]), OVERSEAS: z2.union([z2.object({ name: z2.string(), academicRequirementId: z2.string().optional() }), z2.array(z2.object({ id: z2.string(), name: z2.string(), taskTextOverrides: z2.object({}).optional(), conditionTextOverrides: z2.object({}).optional() }))]) }), languageRequirements: z2.object({ HOME: z2.object({ name: z2.string(), languageRequirementId: z2.string().optional() }), OVERSEAS: z2.object({ name: z2.string(), languageRequirementId: z2.string().optional() }) }), requirements: z2.object({}), availability: z2.object({ type: z2.enum(["all", "limited_partners"]), allowedPartners: z2.array(z2.string()).optional() }), applicationTasks: z2.object({ EnglishLanguage: z2.boolean(), Employment: z2.boolean(), References: z2.boolean(), PersonalStatement: z2.boolean(), ResearchProposal: z2.boolean(), Funding: z2.boolean(), ImmigrationHistory: z2.boolean(), DiversityInclusion: z2.boolean(), Representation: z2.boolean(), Referral: z2.boolean(), Declarations: z2.boolean() }).optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/course/{uni}/{intakeId}/{id}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
            url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/course/{uni}/{intakeId}/{id}
       * @pathParams {uni: string, intakeId: string, id: string}
       * @returns Promise<ApiResponse<boolean>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/course/{uni}/{intakeId}/{id}";
        const pathParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string(), id: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/course/{uni}/{intakeId}/{id}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
            url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    CasShield: {
      /**
       * POST /apply/cas-shield-auth
       * @returns Promise<ApiResponse<{ isAuthenticated: boolean; needsTokenRefresh?: boolean } | ErrorResponse>>
       */
      auth: (() => {
        const method = "POST";
        const path = "/apply/cas-shield-auth";
        const buildUrl = () => "/apply/cas-shield-auth";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    /**
     * GET /apply/your-information
     * @returns Promise<ApiResponse<RouteSection | GetErrorResponse>>
     */
    yourInformation: (() => {
      const method = "GET";
      const path = "/apply/your-information";
      const buildUrl = () => "/apply/your-information";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * GET /apply/status
     * @queryParams z.object({ applicationId: z.string().optional(), offerId: z.string().optional() })
     * @returns Promise<ApiResponse<RouteStatusResponse | GetErrorResponse>>
     */
    status: (() => {
      const method = "GET";
      const path = "/apply/status";
      const queryParamsSchema = z2.object({ applicationId: z2.string().optional(), offerId: z2.string().optional() });
      const buildUrl = () => "/apply/status";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /apply/home
     * @returns Promise<ApiResponse<IHomeGetResponse | undefined | GetErrorResponse>>
     */
    home: (() => {
      const method = "GET";
      const path = "/apply/home";
      const buildUrl = () => "/apply/home";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  Upload: {
    /**
     * POST /upload-url
     * @body z.object({ id: z.string().optional(), university: z.string().optional(), fileName: z.string(), fileType: z.string(), sponsorType: z.string().nullable().optional(), sponsorKey: z.string().nullable().optional(), docType: z.string().nullable().optional(), docKey: z.string().optional(), interviewType: z.string().optional(), eventType: z.string().optional(), eventKey: z.string().optional(), interviewHash: z.string().optional(), attemptHash: z.string().optional() })
     * @returns Promise<ApiResponse<string>>
     */
    getPresignedUrl: (() => {
      const method = "POST";
      const path = "/upload-url";
      const bodySchema = z2.object({ id: z2.string().optional(), university: z2.string().optional(), fileName: z2.string(), fileType: z2.string(), sponsorType: z2.string().nullable().optional(), sponsorKey: z2.string().nullable().optional(), docType: z2.string().nullable().optional(), docKey: z2.string().optional(), interviewType: z2.string().optional(), eventType: z2.string().optional(), eventKey: z2.string().optional(), interviewHash: z2.string().optional(), attemptHash: z2.string().optional() });
      const buildUrl = () => "/upload-url";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        try {
          const validatedBody = bodySchema.parse(args.body);
          return makeRequest(method, url, validatedBody, args.options);
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "request body");
            console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      return Object.assign(fn, {
        method,
        path,
        bodySchema,
        buildUrl
      });
    })()
  },
  Integration: {
    SITS: {
      Outbound: {
        /**
         * GET /sits/{uni}/outbound
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<SitsDeliveries>>
         */
        list: (() => {
          const method = "GET";
          const path = "/sits/{uni}/outbound";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/sits/{uni}/outbound";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /sits/{uni}/{studentNo}/outbound
         * @pathParams {uni: string, studentNo: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        listByStudent: (() => {
          const method = "GET";
          const path = "/sits/{uni}/{studentNo}/outbound";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/sits/{uni}/{studentNo}/outbound";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /sits/{uni}/{studentNo}/outbound/{delivery}/retry
         * @pathParams {uni: string, studentNo: string, delivery: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        retry: (() => {
          const method = "GET";
          const path = "/sits/{uni}/{studentNo}/outbound/{delivery}/retry";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), delivery: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/sits/{uni}/{studentNo}/outbound/{delivery}/retry";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{delivery}", encodeURIComponent(String(validated.delivery)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      StudentRecord: {
        /**
         * GET /sits/{uni}/{studentNo}/record
         * @pathParams {uni: string, studentNo: string}
         * @returns Promise<ApiResponse<APIResponse<SITSStudentRecordResponseBody>>>
         */
        fetch: (() => {
          const method = "GET";
          const path = "/sits/{uni}/{studentNo}/record";
          const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/sits/{uni}/{studentNo}/record";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * POST /sits-transfer
       * @returns Promise<ApiResponse<APIResponse>>
       */
      transfer: (() => {
        const method = "POST";
        const path = "/sits-transfer";
        const buildUrl = () => "/sits-transfer";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * GET /sits/{uni}/ping
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse<SITSPingResponseBody>>>
       */
      ping: (() => {
        const method = "GET";
        const path = "/sits/{uni}/ping";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/sits/{uni}/ping";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Webhook: {
      /**
       * GET /hooks/{uni}/{hookId}
       * @pathParams {uni: string, hookId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/hooks/{uni}/{hookId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), hookId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/hooks/{uni}/{hookId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{hookId}", encodeURIComponent(String(validated.hookId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /hooks/{uni}/{hookId}
       * @pathParams {uni: string, hookId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      update: (() => {
        const method = "PUT";
        const path = "/hooks/{uni}/{hookId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), hookId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/hooks/{uni}/{hookId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{hookId}", encodeURIComponent(String(validated.hookId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /hooks/{uni}/{hookId}
       * @pathParams {uni: string, hookId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/hooks/{uni}/{hookId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), hookId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/hooks/{uni}/{hookId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{hookId}", encodeURIComponent(String(validated.hookId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /hooks/{uni}
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      create: (() => {
        const method = "POST";
        const path = "/hooks/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/hooks/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Webhooks: {
      /**
       * GET /hooks/{uni}
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      list: (() => {
        const method = "GET";
        const path = "/hooks/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/hooks/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Oracle: {
      Outbound: {
        /**
         * GET /oracle/{uni}/outbound
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<unknown>>
         */
        list: (() => {
          const method = "GET";
          const path = "/oracle/{uni}/outbound";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/oracle/{uni}/outbound";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * GET /oracle/{uni}/{userId}/outbound
         * @pathParams {uni: string, userId: string}
         * @returns Promise<ApiResponse<unknown>>
         */
        listByApplicant: (() => {
          const method = "GET";
          const path = "/oracle/{uni}/{userId}/outbound";
          const pathParamsSchema = z2.object({ uni: z2.string(), userId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/oracle/{uni}/{userId}/outbound";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    Outbound: {
      /**
       * GET /deliveries/{integration}/{uni}/outbound
       * @pathParams {integration: string, uni: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      list: (() => {
        const method = "GET";
        const path = "/deliveries/{integration}/{uni}/outbound";
        const pathParamsSchema = z2.object({ integration: z2.string(), uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/deliveries/{integration}/{uni}/outbound";
            url = url.replace("{integration}", encodeURIComponent(String(validated.integration)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /deliveries/{integration}/{uni}/{userId}/outbound
       * @pathParams {integration: string, uni: string, userId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      listByUser: (() => {
        const method = "GET";
        const path = "/deliveries/{integration}/{uni}/{userId}/outbound";
        const pathParamsSchema = z2.object({ integration: z2.string(), uni: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/deliveries/{integration}/{uni}/{userId}/outbound";
            url = url.replace("{integration}", encodeURIComponent(String(validated.integration)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Applicants: {
      ResolveDuplicate: {
        /**
         * POST /deliveries/{integration}/applicants/resolve-duplicate
         * @pathParams {integration: string}
         * @body z.object({ uni: z.string(), applicationId: z.string(), userId: z.string(), isDuplicate: z.boolean(), studentNo: z.string().optional() })
         * @returns Promise<ApiResponse<APIResponse<ResolveDuplicateHandlerResponse>>>
         */
        post: (() => {
          const method = "POST";
          const path = "/deliveries/{integration}/applicants/resolve-duplicate";
          const pathParamsSchema = z2.object({ integration: z2.enum(["oracle", "sits", "ellucian"]) });
          const bodySchema = z2.object({ uni: z2.string(), applicationId: z2.string(), userId: z2.string(), isDuplicate: z2.boolean(), studentNo: z2.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/deliveries/{integration}/applicants/resolve-duplicate";
              url = url.replace("{integration}", encodeURIComponent(String(validated.integration ?? validated.INTEGRATION ?? validated.integration)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      }
    }
  },
  Reports: {
    UnmappedAgents: {
      /**
       * GET /reports/unmapped-agents/{uni}
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      request: (() => {
        const method = "GET";
        const path = "/reports/unmapped-agents/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/reports/unmapped-agents/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    }
  },
  EgressManager: {
    UniStudent: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentChat: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentDocs: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    DocsApproved: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentAudit: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit";
        const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    SitsPing: {
      /**
       * GET /sits/ping
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/sits/ping";
        const buildUrl = () => "/sits/ping";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    OutboundRetry: {
      /**
       * GET /deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry
       * @pathParams {integration: string, uni: string, userId: string, deliverySortKey: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry";
        const pathParamsSchema = z2.object({ integration: z2.string(), uni: z2.string(), userId: z2.string(), deliverySortKey: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry";
            url = url.replace("{integration}", encodeURIComponent(String(validated.integration)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            url = url.replace("{deliverySortKey}", encodeURIComponent(String(validated.deliverySortKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /student/{studentNo}/{intakeId}/{offerId}
     * @pathParams {studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
     */
    student: (() => {
      const method = "GET";
      const path = "/student/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z2.object({ studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  DocumentManager: {
    DocumentsCountPerType: {
      /**
       * GET /documents/count-per-type
       * @body z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() })
       * @returns Promise<ApiResponse<GetCountPerDocumentTypeResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/count-per-type";
        const bodySchema = z2.object({ academicTranscript: z2.number(), passport: z2.number(), personalStatement: z2.number(), photoId: z2.number(), cv: z2.number(), englishTest: z2.number(), referenceLetter: z2.number(), academicCertificate: z2.number(), proofOfAddress: z2.number(), proofOfNameChange: z2.number(), nameAffidavit: z2.number(), birthCert: z2.number(), proofOfImmigrationStatus: z2.number(), proofOfManagerialExperience: z2.number(), proofOfPayment: z2.number(), portfolio: z2.number(), researchProposal: z2.number(), customRequest: z2.number(), customRequirement: z2.number(), staffDocument: z2.number(), staffOnlyRequirement: z2.number() });
        const buildUrl = () => "/documents/count-per-type";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantUpload: {
      /**
       * POST /documents/{uni}/applicant/{applicantId}/upload
       * @pathParams {uni: string, applicantId: string}
       * @body ApplicantDocUploadRequestSchema
       * @returns Promise<ApiResponse<DocumentPresignedUrlResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/documents/{uni}/applicant/{applicantId}/upload";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ApplicantDocUploadRequestSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/upload";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    Applicant: {
      Staff: {
        UploadUrl: {
          /**
           * POST /documents/{uni}/applicant/{applicantId}/staff
           * @pathParams {uni: string, applicantId: string}
           * @body ApplicantDocUploadRequestSchema
           * @returns Promise<ApiResponse<DocumentPresignedUrlResponse | ErrorResponse>>
           */
          post: (() => {
            const method = "POST";
            const path = "/documents/{uni}/applicant/{applicantId}/staff";
            const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
            const bodySchema = ApplicantDocUploadRequestSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/documents/{uni}/applicant/{applicantId}/staff";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                return url;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        /**
         * DELETE /documents/{uni}/applicant/{applicantId}/staff/{docKey}
         * @pathParams {uni: string, applicantId: string, docKey: string}
         * @queryParams z.object({ s3Key: z.string().optional() })
         * @returns Promise<ApiResponse<DeleteStaffInternalDocumentResponse | ErrorResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}";
          const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), docKey: z2.string().optional() });
          const queryParamsSchema = z2.object({ s3Key: z2.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z2.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      }
    },
    DocumentsApplicant: {
      /**
       * GET /documents/{uni}/applicant/{applicantId}/{docType}
       * @pathParams {uni: string, applicantId: string, docType: string}
       * @body z.object({ status: z.enum(['AWAITING', 'UPLOADED_OK', 'UPLOADED_WITH_ERROR', 'REJECTED', 'REJECTED_WITHOUT_ALTERNATIVE', 'APPROVED', 'REPLACED', 'DELETED', 'SKIPPED', 'INFO_ONLY', 'NOT_ACKNOWLEDGED', 'ACKNOWLEDGED']), label: z.string(), fileNames: z.array(z.string()), prevStatus: z.enum(['AWAITING', 'UPLOADED_OK', 'UPLOADED_WITH_ERROR', 'REJECTED', 'REJECTED_WITHOUT_ALTERNATIVE', 'APPROVED', 'REPLACED', 'DELETED', 'SKIPPED', 'INFO_ONLY', 'NOT_ACKNOWLEDGED', 'ACKNOWLEDGED']).optional(), files: z.array(z.object({ label: z.string(), fileName: z.string(), isPdfFile: z.boolean().optional(), noOfPages: z.number().optional(), isProcessing: z.boolean().optional(), fileSize: z.number().optional(), fileType: z.string().optional(), s3Key: z.string().optional() })), reason: z.string().optional(), signedUrls: z.array(z.string()).optional(), uploadedBy: z.enum(['', 'Admin', 'Agent', 'University', 'Enroly', 'SITS']).optional(), userAccess: z.enum(['STAFF_ONLY', 'AGENT_ONLY']).optional(), isProcessingPdf: z.boolean().optional(), eTags: z.array(z.string()).optional(), s3Keys: z.array(z.string()).optional(), fileLabels: z.array(z.string()).optional(), deletedByTTL: z.boolean().optional() })
       * @returns Promise<ApiResponse<GetDocumentsListResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}";
        const pathParamsSchema = z2.object({ docType: z2.string(), uni: z2.string().optional(), applicantId: z2.string().optional() });
        const bodySchema = z2.object({ status: z2.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]), label: z2.string(), fileNames: z2.array(z2.string()), prevStatus: z2.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]).optional(), files: z2.array(z2.object({ label: z2.string(), fileName: z2.string(), isPdfFile: z2.boolean().optional(), noOfPages: z2.number().optional(), isProcessing: z2.boolean().optional(), fileSize: z2.number().optional(), fileType: z2.string().optional(), s3Key: z2.string().optional() })), reason: z2.string().optional(), signedUrls: z2.array(z2.string()).optional(), uploadedBy: z2.enum(["", "Admin", "Agent", "University", "Enroly", "SITS"]).optional(), userAccess: z2.enum(["STAFF_ONLY", "AGENT_ONLY"]).optional(), isProcessingPdf: z2.boolean().optional(), eTags: z2.array(z2.string()).optional(), s3Keys: z2.array(z2.string()).optional(), fileLabels: z2.array(z2.string()).optional(), deletedByTTL: z2.boolean().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * POST /documents/{uni}/applicant/{applicantId}/{docType}/{docKey}
       * @pathParams {uni: string, applicantId: string, docType: string, docKey: string}
       * @body DocumentSchema
       * @returns Promise<ApiResponse<PostDocumentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
        const pathParamsSchema = z2.object({ docType: z2.string(), docKey: z2.string() });
        const bodySchema = DocumentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /documents/{uni}/applicant/{applicantId}/{docType}/{docKey}
       * @pathParams {uni: string, applicantId: string, docType: string, docKey: string}
       * @returns Promise<ApiResponse<APIResponse | ErrorResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
        const pathParamsSchema = z2.object({ docType: z2.string(), docKey: z2.string(), uni: z2.string().optional(), applicantId: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantCountPerType: {
      /**
       * GET /documents/{uni}/applicant/{applicantId}/count-per-type
       * @pathParams {uni: string, applicantId: string}
       * @body z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() })
       * @returns Promise<ApiResponse<GetCountPerDocumentTypeResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/{uni}/applicant/{applicantId}/count-per-type";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = z2.object({ academicTranscript: z2.number(), passport: z2.number(), personalStatement: z2.number(), photoId: z2.number(), cv: z2.number(), englishTest: z2.number(), referenceLetter: z2.number(), academicCertificate: z2.number(), proofOfAddress: z2.number(), proofOfNameChange: z2.number(), nameAffidavit: z2.number(), birthCert: z2.number(), proofOfImmigrationStatus: z2.number(), proofOfManagerialExperience: z2.number(), proofOfPayment: z2.number(), portfolio: z2.number(), researchProposal: z2.number(), customRequest: z2.number(), customRequirement: z2.number(), staffDocument: z2.number(), staffOnlyRequirement: z2.number() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/count-per-type";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    /**
     * DELETE /documents/{docType}/{docKey}
     * @pathParams {docType: string, docKey: string}
     * @returns Promise<ApiResponse<APIResponse | ErrorResponse>>
     */
    documents: (() => {
      const method = "DELETE";
      const path = "/documents/{docType}/{docKey}";
      const pathParamsSchema = z2.object({ docType: z2.string(), docKey: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/documents/{docType}/{docKey}";
          url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
          url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  ApplyManager: {
    ApplicantYourInformation: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/your-information
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<RouteSection | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/your-information";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/your-information";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantApplications: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ attributes: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicationResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const queryParamsSchema = z2.object({ attributes: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    AgentRegister: {
      /**
       * POST /apply/agent/register
       * @body AgentRegistrationSchema
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/register";
        const bodySchema = AgentRegistrationSchema;
        const buildUrl = () => "/apply/agent/register";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    StaffRegister: {
      /**
       * POST /apply/staff/register
       * @body UniStaffRegistrationSchema
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/staff/register";
        const bodySchema = UniStaffRegistrationSchema;
        const buildUrl = () => "/apply/staff/register";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    PartnerRegister: {
      /**
       * POST /apply/partner/register
       * @body ProviderRegistrationSchema
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/partner/register";
        const bodySchema = ProviderRegistrationSchema;
        const buildUrl = () => "/apply/partner/register";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantAgent: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/agent
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<ApplicantAgentResponse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/agent";
        const pathParamsSchema = z2.object({ applicantId: z2.string(), uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/agent";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantWelcome: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/welcome
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<WelcomeGetResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/welcome";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/welcome";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/welcome
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<WelcomePostResponse | GetErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/welcome";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/welcome";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantHome: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/home
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<IHomeGetResponse | undefined | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/home";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/home";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantStatus: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/status
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string().optional(), offerId: z.string().optional() })
       * @returns Promise<ApiResponse<RouteStatusResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/status";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string().optional(), offerId: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantApplicationStatus: {
      /**
       * GET /apply/staff/{uni}/applicant/{applicantId}/{applicationId}/application-status
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string().optional(), offerId: z.string().optional() })
       * @returns Promise<ApiResponse<ApplicationStatusResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/staff/{uni}/applicant/{applicantId}/{applicationId}/application-status";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string().optional(), offerId: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/staff/{uni}/applicant/{applicantId}/{applicationId}/application-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantContactInformation: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/contact-information
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<GetContactInformationResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/contact-information";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/contact-information";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/contact-information
       * @pathParams {uni: string, applicantId: string}
       * @body ContactInformationSchema
       * @returns Promise<ApiResponse<UpdateContactInformationResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/contact-information";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ContactInformationSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/contact-information";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantFeeStatus: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/fee-status
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<GetFeeStatusResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/fee-status";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/fee-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/fee-status
       * @pathParams {uni: string, applicantId: string}
       * @body FeeStatusSchema
       * @returns Promise<ApiResponse<UpdateFeeStatusResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/fee-status";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = FeeStatusSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/fee-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantProgrammeChoices: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/programme-choices
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/programme-choices";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/programme-choices";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/programme-choices
       * @pathParams {uni: string, applicantId: string}
       * @body ProgrammeChoicesSchema
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/programme-choices";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ProgrammeChoicesSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/programme-choices";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantCourses: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/courses
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/courses";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/courses";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantIdentity: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/identity
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @returns Promise<ApiResponse<GetApplicantIdentityResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/identity";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/identity";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/identity
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body ApplicantIdentitySchema
       * @returns Promise<ApiResponse<UpdateApplicantIdentityResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/identity";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ApplicantIdentitySchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/identity";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantOtherNames: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/other-names
       * @pathParams {uni: string, applicantId: string}
       * @body OtherNamePayloadSchema
       * @returns Promise<ApiResponse<CreateOtherNameResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/other-names";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = OtherNamePayloadSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/other-names";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}
       * @pathParams {uni: string, applicantId: string, otherId: string}
       * @body OtherNamePayloadSchema
       * @returns Promise<ApiResponse<UpdateOtherNameResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}";
        const pathParamsSchema = z2.object({});
        const bodySchema = OtherNamePayloadSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{otherId}", encodeURIComponent(String(validated.otherId ?? validated.OTHERID ?? validated.otherId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}
       * @pathParams {uni: string, applicantId: string, otherId: string}
       * @returns Promise<ApiResponse<RemoveOtherNameResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}";
        const pathParamsSchema = z2.object({});
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/other-names/{otherId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{otherId}", encodeURIComponent(String(validated.otherId ?? validated.OTHERID ?? validated.otherId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantNationalityAndResidence: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @returns Promise<ApiResponse<GetNationalityResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body NationalitySchema
       * @returns Promise<ApiResponse<UpdateNationalityResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = NationalitySchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/nationality-and-residence";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantContactDetails: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/contact-details
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @returns Promise<ApiResponse<GetContactDetailsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/contact-details";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/contact-details";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/contact-details
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body ContactDetailsSchema
       * @returns Promise<ApiResponse<UpdateContactDetailsResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/contact-details";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ContactDetailsSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/contact-details";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantStudyHistory: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/study-history
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<GetStudyHistoryResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}
       * @pathParams {uni: string, applicantId: string, studyHistoryId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ country: z.string(), resultStatus: z.enum(['FinalResults', 'InterimResults', 'NoResults']), institutionName: z.string(), institutionAddress: z.object({ addressLine1: z.string(), city: z.string(), postcode: z.string(), addressHasSubdivision: z.boolean(), subdivisionCode: z.string(), addressLine2: z.string().optional(), addressLine3: z.string().optional(), state: z.string().optional() }), date: z.string().optional(), validUntil: z.string().optional(), level: z.enum(['HighSchool', 'Undergraduate', 'Postgraduate']).optional(), taughtInEnglish: z.boolean().optional(), qualificationTypeSelections: z.array(z.object({ qualificationType: z.string(), gradingSystem: z.string(), id: z.string().optional(), resultStatus: z.enum(['FinalResults', 'InterimResults', 'NoResults']).optional(), taughtInEnglish: z.boolean().optional(), qualificationTypeLabel: z.string().optional(), customQualificationTypeName: z.string().optional(), gradingSystemLabel: z.string().optional(), groupId: z.string().optional() })), academicTranscriptDocument: z.object({ s3Keys: z.array(z.string()).nullable(), sKey: z.string().nullable() }).optional(), qualifications: z.object({}).nullable().optional() })
       * @returns Promise<ApiResponse<RemoveStudyHistoryResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}";
        const pathParamsSchema = z2.object({ studyHistoryId: z2.string() });
        const bodySchema = z2.object({ country: z2.string(), resultStatus: z2.enum(["FinalResults", "InterimResults", "NoResults"]), institutionName: z2.string(), institutionAddress: z2.object({ addressLine1: z2.string(), city: z2.string(), postcode: z2.string(), addressHasSubdivision: z2.boolean(), subdivisionCode: z2.string(), addressLine2: z2.string().optional(), addressLine3: z2.string().optional(), state: z2.string().optional() }), date: z2.string().optional(), validUntil: z2.string().optional(), level: z2.enum(["HighSchool", "Undergraduate", "Postgraduate"]).optional(), taughtInEnglish: z2.boolean().optional(), qualificationTypeSelections: z2.array(z2.object({ qualificationType: z2.string(), gradingSystem: z2.string(), id: z2.string().optional(), resultStatus: z2.enum(["FinalResults", "InterimResults", "NoResults"]).optional(), taughtInEnglish: z2.boolean().optional(), qualificationTypeLabel: z2.string().optional(), customQualificationTypeName: z2.string().optional(), gradingSystemLabel: z2.string().optional(), groupId: z2.string().optional() })), academicTranscriptDocument: z2.object({ s3Keys: z2.array(z2.string()).nullable(), sKey: z2.string().nullable() }).optional(), qualifications: z2.object({}).nullable().optional() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    StudyHistoryPrevious: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/previous/{studyHistoryId}
       * @pathParams {uni: string, applicantId: string, studyHistoryId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body StudySchema
       * @returns Promise<ApiResponse<UpdatePreviousStudyHistoryResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/previous/{studyHistoryId}";
        const pathParamsSchema = z2.object({ studyHistoryId: z2.string() });
        const bodySchema = StudySchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/previous/{studyHistoryId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    StudyHistoryHighest: {
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/highest
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<RemoveStudyHistoryResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/highest";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/highest";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    HighestComplete: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/highest/complete
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<CompleteLatestEducationQualificationsResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/highest/complete";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/highest/complete";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantQualifications: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/qualifications
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ countryCode: z.string() })
       * @returns Promise<ApiResponse<GetQualificationsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/qualifications";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ countryCode: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/qualifications";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantAwardingOrganisations: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/awarding-organisations
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ countryCode: z.string(), qualificationTypeId: z.string() })
       * @returns Promise<ApiResponse<GetAwardingOrganisationsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/awarding-organisations";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ countryCode: z2.string(), qualificationTypeId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/awarding-organisations";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    StudyHistoryQualifications: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications
       * @pathParams {uni: string, applicantId: string, studyHistoryId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body QualificationSchema
       * @returns Promise<ApiResponse<CreateQualificationResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications";
        const pathParamsSchema = z2.object({ studyHistoryId: z2.string().optional() });
        const bodySchema = QualificationSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}
       * @pathParams {uni: string, applicantId: string, studyHistoryId: string, qualificationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body QualificationSchema
       * @returns Promise<ApiResponse<UpdateQualificationResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}";
        const pathParamsSchema = z2.object({ qualificationId: z2.string(), studyHistoryId: z2.string().optional() });
        const bodySchema = QualificationSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId ?? validated.QUALIFICATIONID ?? validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}
       * @pathParams {uni: string, applicantId: string, studyHistoryId: string, qualificationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @returns Promise<ApiResponse<RemoveQualificationResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}";
        const pathParamsSchema = z2.object({ qualificationId: z2.string(), studyHistoryId: z2.string().optional() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/{studyHistoryId}/qualifications/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{studyHistoryId}", encodeURIComponent(String(validated.studyHistoryId ?? validated.STUDYHISTORYID ?? validated.studyHistoryId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId ?? validated.QUALIFICATIONID ?? validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    QualificationsComplete: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/latest/qualifications/complete
       * @pathParams {uni: string, applicantId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/latest/qualifications/complete";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/latest/qualifications/complete";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudyHistoryComplete: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}/study-history/complete
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @returns Promise<ApiResponse<CompletePreviousEducationResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}/study-history/complete";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/applications/{applicationId}/study-history/complete";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    StudyHistoryInstitution: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}
       * @pathParams {uni: string, applicantId: string, institutionId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}
       * @pathParams {uni: string, applicantId: string, institutionId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}
       * @pathParams {uni: string, applicantId: string, institutionId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}
       * @pathParams {uni: string, applicantId: string, institutionId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    InstitutionStudy: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudyQualification: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string, qualificationId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string, qualificationId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string, qualificationId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}
       * @pathParams {uni: string, applicantId: string, institutionId: string, studyId: string, qualificationId: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), institutionId: z2.string(), studyId: z2.string(), qualificationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/study-history/institution/{institutionId}/study/{studyId}/qualification/{qualificationId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{institutionId}", encodeURIComponent(String(validated.institutionId)));
            url = url.replace("{studyId}", encodeURIComponent(String(validated.studyId)));
            url = url.replace("{qualificationId}", encodeURIComponent(String(validated.qualificationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantEnglishTest: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/english-test
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
       * @returns Promise<ApiResponse<GetEnglishTestResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/english-test";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/english-test";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/english-test
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body EnglishSchema
       * @returns Promise<ApiResponse<UpdateEnglishTestResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/english-test";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = EnglishSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/english-test";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantEmployment: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/employment
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
       * @returns Promise<ApiResponse<GetEmploymentResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/employment";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/employment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/employment
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body ApplicantEmploymentSchema
       * @returns Promise<ApiResponse<UpdateEmploymentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/employment";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ApplicantEmploymentSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/employment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationReferences: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetReferencesResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @body ReferencesSchema
       * @returns Promise<ApiResponse<UpdateReferencesResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = ReferencesSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/references";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicationPersonalStatement: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetPersonalStatementResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @body PersonalStatementSchema
       * @returns Promise<ApiResponse<UpdatePersonalStatementResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = PersonalStatementSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/personal-statement";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicationResearchProposal: {
      /**
       * GET /apply/application/{applicationId}/research-proposal
       * @pathParams {applicationId: string}
       * @returns Promise<ApiResponse<GetResearchProposalResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/application/{applicationId}/research-proposal";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/application/{applicationId}/research-proposal";
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/application/{applicationId}/research-proposal
       * @pathParams {applicationId: string}
       * @body ResearchProposalSchema
       * @returns Promise<ApiResponse<UpdateResearchProposalResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/application/{applicationId}/research-proposal";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = ResearchProposalSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/application/{applicationId}/research-proposal";
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantVisaHistory: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/visa-history
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
       * @returns Promise<ApiResponse<GetVisaHistoryResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/visa-history";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/visa-history";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/visa-history
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ isVisaRequired: z.boolean().nullable().optional(), visaExemptionReason: z.string().nullable().optional(), hasVisaForCurrentOrPreviousUkStudy: z.boolean().nullable().optional(), hasStudentVisaForThisUkStudy: z.boolean().nullable().optional(), ukStudentVisas: z.array(z.object({ studentVisaType: z.string(), levelOfStudy: z.string(), visaReceivedYear: z.number(), isCourseCompleted: z.boolean(), compareCourse: z.string(), visaNotListedCustomValue: z.string().nullable().optional() })), hasEuEeaSwitzerlandExperience: z.boolean().nullable().optional(), hasEuFamilyMember: z.boolean().nullable().optional(), hasNonStudentVisaOrPermit: z.boolean().nullable().optional(), ukNonStudentVisaOrPermit: z.array(z.object({ studentVisaType: z.string(), issuedDate: z.string(), visaNotListedCustomValue: z.string().nullable().optional(), validTill: z.string().optional() })), hasPreviousVisaRefusal: z.boolean().nullable().optional(), ukVisaRefusals: z.array(z.object({ refusedVisaType: z.string(), visaRefusalYear: z.number() })).nullable().optional(), hasPreviousNonUkVisaRefusal: z.boolean().nullable().optional(), nonUkVisaRefusals: z.array(z.object({ visaRefusalYear: z.number(), visaRefusalCountry: z.string(), isStudentVisaRefused: z.boolean() })).nullable().optional() })
       * @returns Promise<ApiResponse<UpdateVisaHistoryResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/visa-history";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = z2.object({ isVisaRequired: z2.boolean().nullable().optional(), visaExemptionReason: z2.string().nullable().optional(), hasVisaForCurrentOrPreviousUkStudy: z2.boolean().nullable().optional(), hasStudentVisaForThisUkStudy: z2.boolean().nullable().optional(), ukStudentVisas: z2.array(z2.object({ studentVisaType: z2.string(), levelOfStudy: z2.string(), visaReceivedYear: z2.number(), isCourseCompleted: z2.boolean(), compareCourse: z2.string(), visaNotListedCustomValue: z2.string().nullable().optional() })), hasEuEeaSwitzerlandExperience: z2.boolean().nullable().optional(), hasEuFamilyMember: z2.boolean().nullable().optional(), hasNonStudentVisaOrPermit: z2.boolean().nullable().optional(), ukNonStudentVisaOrPermit: z2.array(z2.object({ studentVisaType: z2.string(), issuedDate: z2.string(), visaNotListedCustomValue: z2.string().nullable().optional(), validTill: z2.string().optional() })), hasPreviousVisaRefusal: z2.boolean().nullable().optional(), ukVisaRefusals: z2.array(z2.object({ refusedVisaType: z2.string(), visaRefusalYear: z2.number() })).nullable().optional(), hasPreviousNonUkVisaRefusal: z2.boolean().nullable().optional(), nonUkVisaRefusals: z2.array(z2.object({ visaRefusalYear: z2.number(), visaRefusalCountry: z2.string(), isStudentVisaRefused: z2.boolean() })).nullable().optional() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/visa-history";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantDiversity: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/diversity
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
       * @returns Promise<ApiResponse<GetDiversityResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/diversity";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/diversity";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/diversity
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body DiversitySchema
       * @returns Promise<ApiResponse<UpdateDiversityResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/diversity";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = DiversitySchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/diversity";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationRepresentation: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetRepresentationResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @body RepresentationFormSchema
       * @returns Promise<ApiResponse<UpdateRepresentationResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = RepresentationFormSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/representation";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicationFunding: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetFundingPlanResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @body z.object({ primaryFundingSource: z.enum(['PrivateFinance', 'StudentFinance', 'HealthAuthority', 'ResearchCouncils', 'TrainingAgency', 'UkIndustry', 'UkGovtInternational', 'UkGovtOther', 'UniversityScholarship', 'OverseasAgency', 'OverseasGovt', 'OverseasIndustry', 'OverseasUniversity', 'Other', 'Unknown']), isPlanningToWork: z.boolean(), otherSourceOfFunding: z.string().nullable().optional(), isSLCGrant: z.boolean().nullable().optional(), isSLCLoan: z.boolean().nullable().optional() })
       * @returns Promise<ApiResponse<UpdateFundingPlanResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = z2.object({ primaryFundingSource: z2.enum(["PrivateFinance", "StudentFinance", "HealthAuthority", "ResearchCouncils", "TrainingAgency", "UkIndustry", "UkGovtInternational", "UkGovtOther", "UniversityScholarship", "OverseasAgency", "OverseasGovt", "OverseasIndustry", "OverseasUniversity", "Other", "Unknown"]), isPlanningToWork: z2.boolean(), otherSourceOfFunding: z2.string().nullable().optional(), isSLCGrant: z2.boolean().nullable().optional(), isSLCLoan: z2.boolean().nullable().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/funding";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantReferral: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/referral
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string(), previousRoute: z.string().optional(), nextRoute: z.string().optional(), data: z.unknown() })
       * @returns Promise<ApiResponse<GetApplicantReferralResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/referral";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const queryParamsSchema = z2.object({ applicationId: z2.string(), previousRoute: z2.string().optional(), nextRoute: z2.string().optional(), data: z2.unknown() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/referral";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/referral
       * @pathParams {uni: string, applicantId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body ApplicantReferralSchema
       * @returns Promise<ApiResponse<UpdateApplicantReferralResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/referral";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string() });
        const bodySchema = ApplicantReferralSchema;
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/referral";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationDeclarations: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetDeclarationsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @body DeclarationsSchema
       * @returns Promise<ApiResponse<UpdateDeclarationsResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = DeclarationsSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/declarations";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicationConsent: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/consent
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<GetConsentsResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/consent";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/consent";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationDataAccuracy: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/data-accuracy
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ accuracyOfDataConsent: z.boolean() })
       * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/data-accuracy";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = z2.object({ accuracyOfDataConsent: z2.boolean() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/data-accuracy";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationInformationProcessing: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/information-processing
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ informationProcessingConsent: z.boolean() })
       * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/information-processing";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = z2.object({ informationProcessingConsent: z2.boolean() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/information-processing";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationPrivacyPolicy: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/privacy-policy
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ privacyPolicyConsent: z.boolean() })
       * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/privacy-policy";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = z2.object({ privacyPolicyConsent: z2.boolean() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/privacy-policy";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationTermsAndConditions: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/terms-and-conditions
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @queryParams z.object({ applicationId: z.string() })
       * @body z.object({ termsAndConditionsConsent: z.boolean() })
       * @returns Promise<ApiResponse<UpdateConsentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/terms-and-conditions";
        const pathParamsSchema = z2.object({ applicationId: z2.string() });
        const bodySchema = z2.object({ termsAndConditionsConsent: z2.boolean() });
        const queryParamsSchema = z2.object({ applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/terms-and-conditions";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId ?? validated.APPLICATIONID ?? validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicationSubmit: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/submit
       * @pathParams {uni: string, applicantId: string, applicationId: string}
       * @returns Promise<ApiResponse<SubmitApplicationResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/submit";
        const pathParamsSchema = z2.object({ uni: z2.string(), applicantId: z2.string(), applicationId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/application/{applicationId}/submit";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            url = url.replace("{applicationId}", encodeURIComponent(String(validated.applicationId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantOffers: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @queryParams z.object({ noRequirements: z.string().optional() })
       * @returns Promise<ApiResponse<GetApplicantOfferResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const queryParamsSchema = z2.object({ noRequirements: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })()
    },
    OffersRequirements: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}
       * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
       * @returns Promise<ApiResponse<GetOfferRequirementTaskResponse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}";
        const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}
       * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
       * @body DocumentFulfilmentSchema
       * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}";
        const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
        const bodySchema = DocumentFulfilmentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    RequirementsBookingRequested: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/booking-requested
       * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
       * @returns Promise<ApiResponse<MarkBookingRequestedResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/booking-requested";
        const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/booking-requested";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    RequirementsPassport: {
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/passport
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @body OfferPassportSchema
       * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/passport";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const bodySchema = OfferPassportSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/passport";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    RequirementsEnglishLanguageResults: {
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/english-language-results
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @body EnglishResultsFulfilmentSchema
       * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/english-language-results";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const bodySchema = EnglishResultsFulfilmentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/english-language-results";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    RequirementsRefereeDetails: {
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/referee-details
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @body RefereeDetailsFulfilmentSchema
       * @returns Promise<ApiResponse<UpdateOfferRequirementTaskResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/referee-details";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const bodySchema = RefereeDetailsFulfilmentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/referee-details";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    RequirementsCompletions: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/completions
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @returns Promise<ApiResponse<RequirementCompletionsResponse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/completions";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/completions";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    RequirementsPrefill: {
      /**
       * POST /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/prefill
       * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
       * @body z.object({ sourceOfferId: z.string() })
       * @returns Promise<ApiResponse<GetOfferRequirementTaskResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/prefill";
        const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
        const bodySchema = z2.object({ sourceOfferId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/prefill";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    RequirementsDismissCompletion: {
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/dismiss-completion
       * @pathParams {uni: string, applicantId: string, offerId: string, requirementId: string}
       * @returns Promise<ApiResponse<{ success: boolean } | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/dismiss-completion";
        const pathParamsSchema = z2.object({ offerId: z2.string(), requirementId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/requirements/{requirementId}/dismiss-completion";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            url = url.replace("{requirementId}", encodeURIComponent(String(validated.requirementId ?? validated.REQUIREMENTID ?? validated.requirementId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    OffersPayment: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @queryParams z.object({ getPaymentDoc: z.boolean() })
       * @returns Promise<ApiResponse<GetApplicantOfferPaymentResponse | GetErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const queryParamsSchema = z2.object({ getPaymentDoc: z2.boolean() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            try {
              const validatedQuery = queryParamsSchema.parse(args.queryParams);
              const queryString = buildQueryString(validatedQuery);
              if (queryString) url += "?" + queryString;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "query parameters");
                console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          queryParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @body z.object({ paymentMethod: z.enum(['Deposit', 'Sponsorship', 'SLCFunding']), status: z.enum(['Request', 'Review', 'Exempt', 'Approved']).nullable().optional(), proofOfPayment: z.object({ fileName: z.string().nullable(), s3Keys: z.array(z.string()).nullable(), sKey: z.string().nullable(), status: z.enum(['Request', 'Review', 'Exempt', 'Approved']).nullable().optional(), urls: z.array(z.string()).optional(), statusInternalNote: z.string().nullable().optional() }), statusInternalNote: z.string().nullable().optional(), depositDetail: z.object({ depositAmount: z.number(), paymentDate: z.string() }).nullable().optional(), sponsorshipDetail: z.object({ sponsorType: z.enum(['UkGovernment', 'BritishCouncil', 'YourGovernment', 'InternationalOrganisation', 'InternationalCompany']), sponsorName: z.string(), isSponsorOrgMultinational: z.boolean().nullable().optional() }), slcDetail: z.object({ customerRefNumber: z.string(), studentSupportNumber: z.string() }).nullable().optional() })
       * @returns Promise<ApiResponse<IUpdateApplicantOfferPaymentResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const bodySchema = z2.object({ paymentMethod: z2.enum(["Deposit", "Sponsorship", "SLCFunding"]), status: z2.enum(["Request", "Review", "Exempt", "Approved"]).nullable().optional(), proofOfPayment: z2.object({ fileName: z2.string().nullable(), s3Keys: z2.array(z2.string()).nullable(), sKey: z2.string().nullable(), status: z2.enum(["Request", "Review", "Exempt", "Approved"]).nullable().optional(), urls: z2.array(z2.string()).optional(), statusInternalNote: z2.string().nullable().optional() }), statusInternalNote: z2.string().nullable().optional(), depositDetail: z2.object({ depositAmount: z2.number(), paymentDate: z2.string() }).nullable().optional(), sponsorshipDetail: z2.object({ sponsorType: z2.enum(["UkGovernment", "BritishCouncil", "YourGovernment", "InternationalOrganisation", "InternationalCompany"]), sponsorName: z2.string(), isSponsorOrgMultinational: z2.boolean().nullable().optional() }), slcDetail: z2.object({ customerRefNumber: z2.string(), studentSupportNumber: z2.string() }).nullable().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/payment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    OffersProofOfPayment: {
      /**
       * GET /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @returns Promise<ApiResponse<GetOfferProofOfPaymentResponse | ErrorResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment
       * @pathParams {uni: string, applicantId: string, offerId: string}
       * @body ProofOfPaymentSchema
       * @returns Promise<ApiResponse<IUpdateOfferProofOfPaymentResponse | ErrorResponse>>
       */
      put: (() => {
        const method = "PUT";
        const path = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment";
        const pathParamsSchema = z2.object({ offerId: z2.string() });
        const bodySchema = ProofOfPaymentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/apply/agent/{uni}/applicant/{applicantId}/offers/{offerId}/proof-of-payment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    }
  },
  Students: {
    BulkChange: {
      Stage: {
        /**
         * POST /students/{uni}/bulk-action/stage
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        assign: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/stage";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/stage";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      ImmigrationProvider: {
        /**
         * POST /students/{uni}/bulk-action/immigration-provider
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        assign: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/immigration-provider";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/immigration-provider";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RecordedInterview: {
        /**
         * POST /students/{uni}/bulk-action/recorded-interview/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/recorded-interview/remove";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/recorded-interview/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/recorded-interview/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/recorded-interview/add";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/recorded-interview/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CalendlyInterview: {
        /**
         * POST /students/{uni}/bulk-action/scheduled-interview/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/scheduled-interview/remove";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/scheduled-interview/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/scheduled-interview/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/scheduled-interview/add";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/scheduled-interview/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Tags: {
        /**
         * POST /students/{uni}/bulk-action/tags/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/tags/add";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/tags/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/tags/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/tags/remove";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/tags/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/tags/pin
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pin: (() => {
          const method = "POST";
          const path = "/students/{uni}/tags/pin";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/tags/pin";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/tags/unpin
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        unpin: (() => {
          const method = "POST";
          const path = "/students/{uni}/tags/unpin";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/tags/unpin";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Partners: {
        /**
         * POST /students/{uni}/bulk-action/partners/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/partners/add";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/partners/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/partners/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/partners/remove";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/partners/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    ImmigrationProvider: {
      /**
       * POST /students/{uni}/immigration-provider/update
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      update: (() => {
        const method = "POST";
        const path = "/students/{uni}/immigration-provider/update";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/immigration-provider/update";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /students/{uni}/immigration-provider/remove
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      remove: (() => {
        const method = "POST";
        const path = "/students/{uni}/immigration-provider/remove";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/immigration-provider/remove";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Partners: {
      /**
       * POST /students/{uni}/partners/add
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      add: (() => {
        const method = "POST";
        const path = "/students/{uni}/partners/add";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/partners/add";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /students/{uni}/partners/remove
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      remove: (() => {
        const method = "POST";
        const path = "/students/{uni}/partners/remove";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/partners/remove";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * POST /students/bulkChange
     * @returns Promise<ApiResponse<APIResponse>>
     */
    bulkChange: (() => {
      const method = "POST";
      const path = "/students/bulkChange";
      const buildUrl = () => "/students/bulkChange";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/reset-import-hashes
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    importHashesReset: (() => {
      const method = "POST";
      const path = "/students/{uni}/reset-import-hashes";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/reset-import-hashes";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students
     * @queryParams z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(['asc', 'desc']).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() })
     * @returns Promise<ApiResponse<GetStudentsResponse>>
     */
    list: (() => {
      const method = "GET";
      const path = "/get-students";
      const queryParamsSchema = z2.object({ uni: z2.string().optional(), intakeId: z2.string().optional(), pathway: z2.string().optional(), stage: z2.string().optional(), limit: z2.number().optional(), offset: z2.number().optional(), sortBy: z2.string().optional(), sortOrder: z2.enum(["asc", "desc"]).optional(), search: z2.string().optional(), pathwayVisibility: z2.string().optional(), message: z2.boolean().optional(), startDate: z2.string().optional(), endDate: z2.string().optional(), unis: z2.unknown().optional(), studentNo: z2.unknown().optional(), givenName: z2.unknown().optional(), surname: z2.unknown().optional(), course: z2.unknown().optional(), faculty: z2.unknown().optional(), nationality: z2.unknown().optional(), country: z2.unknown().optional(), applicationCountry: z2.unknown().optional(), activityStatus: z2.unknown().optional(), notStarted: z2.unknown().optional(), idle: z2.unknown().optional(), complete: z2.unknown().optional(), incomplete: z2.unknown().optional(), fundsMaturity: z2.unknown().optional(), market: z2.unknown().optional(), region: z2.unknown().optional(), visaStatus: z2.unknown().optional(), confidence: z2.unknown().optional(), agent: z2.unknown().optional(), conditionalStatus: z2.unknown().optional(), courseConditionalStatus: z2.unknown().optional(), courseCondtionalStatus: z2.unknown().optional(), evidenceRequirements: z2.unknown().optional(), customRegion: z2.unknown().optional(), tag: z2.unknown().optional(), programmableTag: z2.unknown().optional(), services: z2.unknown().optional(), immigrationProviders: z2.unknown().optional(), interview: z2.unknown().optional(), recordedInterview: z2.unknown().optional(), idleFrom: z2.unknown().optional(), idleTo: z2.unknown().optional(), dependants: z2.unknown().optional(), tagsMatch: z2.unknown().optional(), programmableTagsMatch: z2.unknown().optional() });
      const buildUrl = () => "/get-students";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/totals
     * @queryParams z.object({ uni: z.string(), intakeId: z.string().optional() })
     * @returns Promise<ApiResponse<StudentTotalsResponse>>
     */
    totals: (() => {
      const method = "GET";
      const path = "/get-students/totals";
      const queryParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string().optional() });
      const buildUrl = () => "/get-students/totals";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/filters
     * @queryParams z.object({ uni: z.string(), intakeId: z.string().optional() })
     * @returns Promise<ApiResponse<StudentFiltersResponse>>
     */
    filters: (() => {
      const method = "GET";
      const path = "/get-students/filters";
      const queryParamsSchema = z2.object({ uni: z2.string(), intakeId: z2.string().optional() });
      const buildUrl = () => "/get-students/filters";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/ids
     * @queryParams z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(['asc', 'desc']).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() })
     * @returns Promise<ApiResponse<StudentIdsResponse>>
     */
    ids: (() => {
      const method = "GET";
      const path = "/get-students/ids";
      const queryParamsSchema = z2.object({ uni: z2.string().optional(), intakeId: z2.string().optional(), pathway: z2.string().optional(), stage: z2.string().optional(), limit: z2.number().optional(), offset: z2.number().optional(), sortBy: z2.string().optional(), sortOrder: z2.enum(["asc", "desc"]).optional(), search: z2.string().optional(), pathwayVisibility: z2.string().optional(), message: z2.boolean().optional(), startDate: z2.string().optional(), endDate: z2.string().optional(), unis: z2.unknown().optional(), studentNo: z2.unknown().optional(), givenName: z2.unknown().optional(), surname: z2.unknown().optional(), course: z2.unknown().optional(), faculty: z2.unknown().optional(), nationality: z2.unknown().optional(), country: z2.unknown().optional(), applicationCountry: z2.unknown().optional(), activityStatus: z2.unknown().optional(), notStarted: z2.unknown().optional(), idle: z2.unknown().optional(), complete: z2.unknown().optional(), incomplete: z2.unknown().optional(), fundsMaturity: z2.unknown().optional(), market: z2.unknown().optional(), region: z2.unknown().optional(), visaStatus: z2.unknown().optional(), confidence: z2.unknown().optional(), agent: z2.unknown().optional(), conditionalStatus: z2.unknown().optional(), courseConditionalStatus: z2.unknown().optional(), courseCondtionalStatus: z2.unknown().optional(), evidenceRequirements: z2.unknown().optional(), customRegion: z2.unknown().optional(), tag: z2.unknown().optional(), programmableTag: z2.unknown().optional(), services: z2.unknown().optional(), immigrationProviders: z2.unknown().optional(), interview: z2.unknown().optional(), recordedInterview: z2.unknown().optional(), idleFrom: z2.unknown().optional(), idleTo: z2.unknown().optional(), dependants: z2.unknown().optional(), tagsMatch: z2.unknown().optional(), programmableTagsMatch: z2.unknown().optional() });
      const buildUrl = () => "/get-students/ids";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })()
  },
  Auth: {
    SSO: {
      /**
       * POST /auth/sso/token
       * @returns Promise<ApiResponse<APIResponse>>
       */
      signin: (() => {
        const method = "POST";
        const path = "/auth/sso/token";
        const buildUrl = () => "/auth/sso/token";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    MFA: {
      Status: {
        /**
         * GET /users/mfa/status
         * @returns Promise<ApiResponse<IMfaStatusResponse | APIResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/users/mfa/status";
          const buildUrl = () => "/users/mfa/status";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })(),
        /**
         * POST /users/mfa/status
         * @returns Promise<ApiResponse<IUser | APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/users/mfa/status";
          const buildUrl = () => "/users/mfa/status";
          const fn = async (args) => {
            let url = buildUrl();
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            buildUrl
          });
        })()
      },
      /**
       * GET /users/mfa/setup
       * @returns Promise<ApiResponse<AssociateSoftwareTokenCommandOutput | GetUserAttributeVerificationCodeCommandOutput | APIResponse | undefined>>
       */
      setup: (() => {
        const method = "GET";
        const path = "/users/mfa/setup";
        const buildUrl = () => "/users/mfa/setup";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /users/mfa/setup
       * @returns Promise<ApiResponse<IUser | APIResponse>>
       */
      verify: (() => {
        const method = "POST";
        const path = "/users/mfa/setup";
        const buildUrl = () => "/users/mfa/setup";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /auth/mfa/signin
       * @returns Promise<ApiResponse<AdminRespondToAuthChallengeCommandOutput | APIResponse>>
       */
      signIn: (() => {
        const method = "POST";
        const path = "/auth/mfa/signin";
        const buildUrl = () => "/auth/mfa/signin";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /users/mfa/reset
       * @returns Promise<ApiResponse<IUser | APIResponse>>
       */
      reset: (() => {
        const method = "POST";
        const path = "/users/mfa/reset";
        const buildUrl = () => "/users/mfa/reset";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })(),
      /**
       * POST /users/mfa/skip
       * @body z.object({ uni: z.string(), pathway: z.string().optional() })
       * @returns Promise<ApiResponse<IUser | APIResponse>>
       */
      skip: (() => {
        const method = "POST";
        const path = "/users/mfa/skip";
        const bodySchema = z2.object({ uni: z2.string(), pathway: z2.string().optional() });
        const buildUrl = () => "/users/mfa/skip";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    /**
     * POST /users/whoami
     * @returns Promise<ApiResponse<ISignInResponse | APIResponse>>
     */
    whoAmI: (() => {
      const method = "POST";
      const path = "/users/whoami";
      const buildUrl = () => "/users/whoami";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/signin
     * @returns Promise<ApiResponse<ISignInResponse | APIResponse>>
     */
    signIn: (() => {
      const method = "POST";
      const path = "/auth/signin";
      const buildUrl = () => "/auth/signin";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/completeNewPassword
     * @returns Promise<ApiResponse<AdminRespondToAuthChallengeCommandOutput | APIResponse>>
     */
    completeNewPassword: (() => {
      const method = "POST";
      const path = "/auth/completeNewPassword";
      const buildUrl = () => "/auth/completeNewPassword";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/signOut
     * @returns Promise<ApiResponse<GlobalSignOutCommandOutput | APIResponse>>
     */
    signOut: (() => {
      const method = "POST";
      const path = "/auth/signOut";
      const buildUrl = () => "/auth/signOut";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/forgotPassword
     * @returns Promise<ApiResponse<ForgotPasswordResponse | APIResponse>>
     */
    forgotPassword: (() => {
      const method = "POST";
      const path = "/auth/forgotPassword";
      const buildUrl = () => "/auth/forgotPassword";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/confirmForgotPassword
     * @returns Promise<ApiResponse<ConfirmForgotPasswordCommandOutput | APIResponse | string>>
     */
    forgotPasswordConfirm: (() => {
      const method = "POST";
      const path = "/auth/confirmForgotPassword";
      const buildUrl = () => "/auth/confirmForgotPassword";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /auth/refreshSession
     * @returns Promise<ApiResponse<AdminInitiateAuthCommandOutput | APIResponse>>
     */
    refreshSession: (() => {
      const method = "POST";
      const path = "/auth/refreshSession";
      const buildUrl = () => "/auth/refreshSession";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  Users: {
    Uni: {
      Students: {
        /**
         * GET /users/{uni}/students
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
         */
        list: (() => {
          const method = "GET";
          const path = "/users/{uni}/students";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/{uni}/students";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Staff: {
        /**
         * GET /users/uni/{uni}/staff
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
         */
        list: (() => {
          const method = "GET";
          const path = "/users/uni/{uni}/staff";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/uni/{uni}/staff";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    Pathway: {
      Students: {
        /**
         * GET /users/pathway/{pathway}/uni/{uni}/students
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
         */
        list: (() => {
          const method = "GET";
          const path = "/users/pathway/{pathway}/uni/{uni}/students";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/pathway/{pathway}/uni/{uni}/students";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    Agents: {
      /**
       * GET /users/agents
       * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
       */
      list: (() => {
        const method = "GET";
        const path = "/users/agents";
        const buildUrl = () => "/users/agents";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Agent: {
      /**
       * GET /users/agents/{agent}
       * @pathParams {agent: string}
       * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
       */
      list: (() => {
        const method = "GET";
        const path = "/users/agents/{agent}";
        const pathParamsSchema = z2.object({ agent: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/agents/{agent}";
            url = url.replace("{agent}", encodeURIComponent(String(validated.agent)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /users/agents/userId/{userId}/terms
       * @pathParams {userId: string}
       * @returns Promise<ApiResponse<{ userId: string }>>
       */
      acceptTerms: (() => {
        const method = "PUT";
        const path = "/users/agents/userId/{userId}/terms";
        const pathParamsSchema = z2.object({ userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/agents/userId/{userId}/terms";
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Admins: {
      /**
       * GET /users/admin
       * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser | IUserLogins> }>>
       */
      list: (() => {
        const method = "GET";
        const path = "/users/admin";
        const buildUrl = () => "/users/admin";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Partners: {
      /**
             * GET /users/partner
             * @returns Promise<ApiResponse<{
        numberOfUsers: number;
        users: Array<IUser>;
      }>>
             */
      list: (() => {
        const method = "GET";
        const path = "/users/partner";
        const buildUrl = () => "/users/partner";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    ImmigrationProviders: {
      /**
       * GET /users/immigration-provider
       * @returns Promise<ApiResponse<{ numberOfUsers: number; users: Array<IUser> }>>
       */
      list: (() => {
        const method = "GET";
        const path = "/users/immigration-provider";
        const buildUrl = () => "/users/immigration-provider";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    /**
     * POST /users/userType/{userType}
     * @pathParams {userType: string}
     * @returns Promise<ApiResponse<{ user: IUser } | APIResponse>>
     */
    add: (() => {
      const method = "POST";
      const path = "/users/userType/{userType}";
      const pathParamsSchema = z2.object({ userType: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/userType/{userType}";
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  User: {
    Uni: {
      Student: {
        /**
                 * GET /users/uni/{uni}/students/userId/{userId}/reinvite
                 * @pathParams {uni: string, userId: string}
                 * @returns Promise<ApiResponse<{
          status: string;
          message: string;
        }>>
                 */
        reinvite: (() => {
          const method = "GET";
          const path = "/users/uni/{uni}/students/userId/{userId}/reinvite";
          const pathParamsSchema = z2.object({ uni: z2.string(), userId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/uni/{uni}/students/userId/{userId}/reinvite";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Staff: {
        /**
         * GET /users/uni/{uni}/userType/{userType}/userId/{userId}/reinvite
         * @pathParams {uni: string, userType: string, userId: string}
         * @returns Promise<ApiResponse<{ userId: string }>>
         */
        reinvite: (() => {
          const method = "GET";
          const path = "/users/uni/{uni}/userType/{userType}/userId/{userId}/reinvite";
          const pathParamsSchema = z2.object({ uni: z2.string(), userType: z2.string(), userId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/uni/{uni}/userType/{userType}/userId/{userId}/reinvite";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
              url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /users/uni/{uni}/userType/{userType}/userId/{userId}/reset
       * @pathParams {uni: string, userType: string, userId: string}
       * @returns Promise<ApiResponse<ForgotPasswordResponse | APIResponse>>
       */
      resetPassword: (() => {
        const method = "GET";
        const path = "/users/uni/{uni}/userType/{userType}/userId/{userId}/reset";
        const pathParamsSchema = z2.object({ uni: z2.string(), userType: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/uni/{uni}/userType/{userType}/userId/{userId}/reset";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /users/uni/{uni}/userType/{userType}
       * @pathParams {uni: string, userType: string}
       * @returns Promise<ApiResponse<{ user: IUser } | APIResponse>>
       */
      addUser: (() => {
        const method = "POST";
        const path = "/users/uni/{uni}/userType/{userType}";
        const pathParamsSchema = z2.object({ uni: z2.string(), userType: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/uni/{uni}/userType/{userType}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /users/uni/{uni}/userType/{userType}/userId/{userId}
       * @pathParams {uni: string, userType: string, userId: string}
       * @returns Promise<ApiResponse<{ user: IUser } | APIResponse>>
       */
      updateUser: (() => {
        const method = "PUT";
        const path = "/users/uni/{uni}/userType/{userType}/userId/{userId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), userType: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/uni/{uni}/userType/{userType}/userId/{userId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /users/uni/{uni}/userId/{userId}
       * @pathParams {uni: string, userId: string}
       * @returns Promise<ApiResponse<{ user: string }>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/users/uni/{uni}/userId/{userId}";
        const pathParamsSchema = z2.object({ uni: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/uni/{uni}/userId/{userId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Pathway: {
      Student: {
        /**
                 * GET /users/pathway/{pathway}/uni/{uni}/students/userId/{userId}/reinvite
                 * @pathParams {pathway: string, uni: string, userId: string}
                 * @returns Promise<ApiResponse<{
          status: string;
          message: string;
        }>>
                 */
        reinvite: (() => {
          const method = "GET";
          const path = "/users/pathway/{pathway}/uni/{uni}/students/userId/{userId}/reinvite";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), userId: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/users/pathway/{pathway}/uni/{uni}/students/userId/{userId}/reinvite";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * GET /users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}/reset
       * @pathParams {pathway: string, uni: string, userType: string, userId: string}
       * @returns Promise<ApiResponse<ForgotPasswordResponse | APIResponse>>
       */
      resetPassword: (() => {
        const method = "GET";
        const path = "/users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}/reset";
        const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), userType: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}/reset";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * PUT /users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}
       * @pathParams {pathway: string, uni: string, userType: string, userId: string}
       * @returns Promise<ApiResponse<{ user: IUser } | APIResponse>>
       */
      updateUser: (() => {
        const method = "PUT";
        const path = "/users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}";
        const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), userType: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/pathway/{pathway}/uni/{uni}/userType/{userType}/userId/{userId}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /users/pathway/{pathway}/uni/{uni}/userId/{userId}
       * @pathParams {pathway: string, uni: string, userId: string}
       * @returns Promise<ApiResponse<{ user: string }>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/users/pathway/{pathway}/uni/{uni}/userId/{userId}";
        const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/pathway/{pathway}/uni/{uni}/userId/{userId}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Staff: {
      /**
       * GET /users/userType/{userType}/userId/{userId}/reinvite
       * @pathParams {userType: string, userId: string}
       * @returns Promise<ApiResponse<{ userId: string }>>
       */
      reinvite: (() => {
        const method = "GET";
        const path = "/users/userType/{userType}/userId/{userId}/reinvite";
        const pathParamsSchema = z2.object({ userType: z2.string(), userId: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/users/userType/{userType}/userId/{userId}/reinvite";
            url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /users/userType/{userType}/userId/{userId}/reset
     * @pathParams {userType: string, userId: string}
     * @returns Promise<ApiResponse<ForgotPasswordResponse | APIResponse>>
     */
    resetPassword: (() => {
      const method = "GET";
      const path = "/users/userType/{userType}/userId/{userId}/reset";
      const pathParamsSchema = z2.object({ userType: z2.string(), userId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/userType/{userType}/userId/{userId}/reset";
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /users/userType/{userType}/userId/{userId}
     * @pathParams {userType: string, userId: string}
     * @returns Promise<ApiResponse<IUser | APIResponse>>
     */
    getUser: (() => {
      const method = "GET";
      const path = "/users/userType/{userType}/userId/{userId}";
      const pathParamsSchema = z2.object({ userType: z2.string(), userId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/userType/{userType}/userId/{userId}";
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /users/uni/{uni}/userType/{userType}/userId/{userId}
     * @pathParams {uni: string, userType: string, userId: string}
     * @returns Promise<ApiResponse<IUser | APIResponse>>
     */
    getStaffUser: (() => {
      const method = "GET";
      const path = "/users/uni/{uni}/userType/{userType}/userId/{userId}";
      const pathParamsSchema = z2.object({ uni: z2.string(), userType: z2.string(), userId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/uni/{uni}/userType/{userType}/userId/{userId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /users/userType/{userType}/userId/{userId}
     * @pathParams {userType: string, userId: string}
     * @returns Promise<ApiResponse<{ user: IUser } | APIResponse>>
     */
    updateUser: (() => {
      const method = "PUT";
      const path = "/users/userType/{userType}/userId/{userId}";
      const pathParamsSchema = z2.object({ userType: z2.string(), userId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/userType/{userType}/userId/{userId}";
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /users/userType/{userType}/userId/{userId}
     * @pathParams {userType: string, userId: string}
     * @returns Promise<ApiResponse<{ user: string }>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/users/userType/{userType}/userId/{userId}";
      const pathParamsSchema = z2.object({ userType: z2.string(), userId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/users/userType/{userType}/userId/{userId}";
          url = url.replace("{userType}", encodeURIComponent(String(validated.userType)));
          url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  UserManagement: {
    ApplyRegister: {
      /**
       * POST /auth/apply/register/{UNIVERSITY}
       * @pathParams {UNIVERSITY: string}
       * @body ApplicantRegistrationSchema
       * @returns Promise<ApiResponse<RegisterResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/auth/apply/register/{UNIVERSITY}";
        const pathParamsSchema = z2.object({ UNIVERSITY: z2.string() });
        const bodySchema = ApplicantRegistrationSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/auth/apply/register/{UNIVERSITY}";
            url = url.replace("{UNIVERSITY}", encodeURIComponent(String(validated.UNIVERSITY ?? validated.UNIVERSITY ?? validated.UNIVERSITY)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    }
  },
  System: {
    EnvVars: {
      /**
       * GET /system/env-variables
       * @returns Promise<ApiResponse<APIResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/system/env-variables";
        const buildUrl = () => "/system/env-variables";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Uni: {
      Apply: {
        /**
                 * POST /system/config/uni/{uni}/apply
                 * @pathParams {uni: string}
                 * @body ApplyConfigSchema
                 * @returns Promise<ApiResponse<{
          config: ISystemAndUniConfig;
          applyConfig: IApplyUniConfig;
        }>>
                 */
        update: (() => {
          const method = "POST";
          const path = "/system/config/uni/{uni}/apply";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const bodySchema = ApplyConfigSchema;
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/system/config/uni/{uni}/apply";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      Emails: {
        /**
         * GET /system/get-email-objects/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<unknown>>
         */
        get: (() => {
          const method = "GET";
          const path = "/system/get-email-objects/{uni}";
          const pathParamsSchema = z2.object({ uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/system/get-email-objects/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * POST /system/add-uni
       * @body z.object({ urlPrefix: z.string(), uniCode: z.string(), uniName: z.string(), jurisdiction: z.string().optional() })
       * @returns Promise<ApiResponse<{ uniList: Array<{ label: string; value: string }> }>>
       */
      add: (() => {
        const method = "POST";
        const path = "/system/add-uni";
        const bodySchema = z2.object({ urlPrefix: z2.string(), uniCode: z2.string(), uniName: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = () => "/system/add-uni";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /system/add-uni
       * @body z.object({ urlPrefix: z.string(), uniCode: z.string(), uniName: z.string(), jurisdiction: z.string().optional() })
       * @returns Promise<ApiResponse<{ uniList: Array<IUniId> }>>
       */
      hydrate: (() => {
        const method = "PUT";
        const path = "/system/add-uni";
        const bodySchema = z2.object({ urlPrefix: z2.string(), uniCode: z2.string(), uniName: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = () => "/system/add-uni";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /config/system/uni/{uni}
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<IUniSysConfigResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/system/uni/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/uni/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
           * POST /config/system/uni/{uni}
           * @pathParams {uni: string}
           * @returns Promise<ApiResponse<| { config: Partial<ISystemAndUniConfig>; regionConfig: IRegionConfig; applyConfig: Partial<IApplyUniConfig> }
      | APIResponse>>
           */
      update: (() => {
        const method = "POST";
        const path = "/config/system/uni/{uni}";
        const pathParamsSchema = z2.object({ uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/uni/{uni}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    PathwayProvider: {
      /**
       * POST /system/add-provider
       * @body z.object({ urlPrefix: z.string(), providerName: z.string(), providerCode: z.string(), jurisdiction: z.string().optional() })
       * @returns Promise<ApiResponse<{ uniList: Array<{ label: string; value: string }> }>>
       */
      add: (() => {
        const method = "POST";
        const path = "/system/add-provider";
        const bodySchema = z2.object({ urlPrefix: z2.string(), providerName: z2.string(), providerCode: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = () => "/system/add-provider";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /system/add-provider
       * @body z.object({ urlPrefix: z.string(), providerCode: z.string(), jurisdiction: z.string().optional() })
       * @returns Promise<ApiResponse<void>>
       */
      hydrate: (() => {
        const method = "PUT";
        const path = "/system/add-provider";
        const bodySchema = z2.object({ urlPrefix: z2.string(), providerCode: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = () => "/system/add-provider";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /config/system/pathway/{pathway}
       * @pathParams {pathway: string}
       * @returns Promise<ApiResponse<{ config: any; }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/system/pathway/{pathway}";
        const pathParamsSchema = z2.object({ pathway: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/pathway/{pathway}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /config/system/pathway/{pathway}
       * @pathParams {pathway: string}
       * @returns Promise<ApiResponse<{ config: Partial<ISystemAndUniConfig> }>>
       */
      update: (() => {
        const method = "POST";
        const path = "/config/system/pathway/{pathway}";
        const pathParamsSchema = z2.object({ pathway: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/pathway/{pathway}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    PathwayUni: {
      /**
             * POST /system/provider/{providerCode}/add-pathway
             * @pathParams {providerCode: string}
             * @body z.object({ urlPrefix: z.string(), uniCode: z.string(), jurisdiction: z.string().optional() })
             * @returns Promise<ApiResponse<{
        uniList: Array<{ label: string; value: string }>;
        pathwayList: Array<IPathwayId>;
      }>>
             */
      add: (() => {
        const method = "POST";
        const path = "/system/provider/{providerCode}/add-pathway";
        const pathParamsSchema = z2.object({ providerCode: z2.string() });
        const bodySchema = z2.object({ urlPrefix: z2.string(), uniCode: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/system/provider/{providerCode}/add-pathway";
            url = url.replace("{providerCode}", encodeURIComponent(String(validated.providerCode ?? validated.PROVIDERCODE ?? validated.providerCode)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /system/provider/{providerCode}/add-pathway
       * @pathParams {providerCode: string}
       * @body z.object({ urlPrefix: z.string(), uniCode: z.string(), jurisdiction: z.string().optional() })
       * @returns Promise<ApiResponse<{ urls: IUrls; pathwayList: Array<IPathwayId> }>>
       */
      hydrate: (() => {
        const method = "PUT";
        const path = "/system/provider/{providerCode}/add-pathway";
        const pathParamsSchema = z2.object({ providerCode: z2.string() });
        const bodySchema = z2.object({ urlPrefix: z2.string(), uniCode: z2.string(), jurisdiction: z2.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/system/provider/{providerCode}/add-pathway";
            url = url.replace("{providerCode}", encodeURIComponent(String(validated.providerCode ?? validated.PROVIDERCODE ?? validated.providerCode)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /config/system/pathway/{pathway}/uni/{uni}
       * @pathParams {pathway: string, uni: string}
       * @returns Promise<ApiResponse<IPathwaySysConfigResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/system/pathway/{pathway}/uni/{uni}";
        const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/pathway/{pathway}/uni/{uni}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /config/system/pathway/{pathway}/uni/{uni}
       * @pathParams {pathway: string, uni: string}
       * @returns Promise<ApiResponse<{ config: Partial<ISystemAndUniConfig>; regionConfig: IRegionConfig }>>
       */
      update: (() => {
        const method = "POST";
        const path = "/config/system/pathway/{pathway}/uni/{uni}";
        const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/pathway/{pathway}/uni/{uni}";
            url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Partner: {
      /**
       * POST /system/add-partner
       * @body z.object({ urlPrefix: z.string(), partnerName: z.string(), partnerCode: z.string(), relatedUnis: z.string() })
       * @returns Promise<ApiResponse<{ partnerList: Array<{ label: string; value: string }> }>>
       */
      add: (() => {
        const method = "POST";
        const path = "/system/add-partner";
        const bodySchema = z2.object({ urlPrefix: z2.string(), partnerName: z2.string(), partnerCode: z2.string(), relatedUnis: z2.string() });
        const buildUrl = () => "/system/add-partner";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /system/add-partner
       * @body z.object({ urlPrefix: z.string(), partnerName: z.string(), partnerCode: z.string() })
       * @returns Promise<ApiResponse<void>>
       */
      hydrate: (() => {
        const method = "PUT";
        const path = "/system/add-partner";
        const bodySchema = z2.object({ urlPrefix: z2.string(), partnerName: z2.string(), partnerCode: z2.string() });
        const buildUrl = () => "/system/add-partner";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /config/system/partner/{partner}
       * @pathParams {partner: string}
       * @returns Promise<ApiResponse<{ config: Partial<ISystemAndUniConfig> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/system/partner/{partner}";
        const pathParamsSchema = z2.object({ partner: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/partner/{partner}";
            url = url.replace("{partner}", encodeURIComponent(String(validated.partner)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /config/system/partner/{partner}
       * @pathParams {partner: string}
       * @returns Promise<ApiResponse<{ config: IUniConfig }>>
       */
      update: (() => {
        const method = "POST";
        const path = "/config/system/partner/{partner}";
        const pathParamsSchema = z2.object({ partner: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/partner/{partner}";
            url = url.replace("{partner}", encodeURIComponent(String(validated.partner)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ImmigrationProvider: {
      /**
       * POST /system/add-immigration-provider
       * @body z.object({ urlPrefix: z.string(), providerName: z.string(), relatedUnis: z.string(), shortCode: z.string().optional() })
       * @returns Promise<ApiResponse<void>>
       */
      add: (() => {
        const method = "POST";
        const path = "/system/add-immigration-provider";
        const bodySchema = z2.object({ urlPrefix: z2.string(), providerName: z2.string(), relatedUnis: z2.string(), shortCode: z2.string().optional() });
        const buildUrl = () => "/system/add-immigration-provider";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * PUT /system/add-immigration-provider
       * @body z.object({ urlPrefix: z.string(), providerName: z.string(), shortCode: z.string() })
       * @returns Promise<ApiResponse<void>>
       */
      hydrate: (() => {
        const method = "PUT";
        const path = "/system/add-immigration-provider";
        const bodySchema = z2.object({ urlPrefix: z2.string(), providerName: z2.string(), shortCode: z2.string() });
        const buildUrl = () => "/system/add-immigration-provider";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * GET /config/system/immigration-provider/{immigrationProvider}
       * @pathParams {immigrationProvider: string}
       * @returns Promise<ApiResponse<{ config: Partial<ISystemAndUniConfig> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/config/system/immigration-provider/{immigrationProvider}";
        const pathParamsSchema = z2.object({ immigrationProvider: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/immigration-provider/{immigrationProvider}";
            url = url.replace("{immigrationProvider}", encodeURIComponent(String(validated.immigrationProvider)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /config/system/immigration-provider/{immigrationProvider}
       * @pathParams {immigrationProvider: string}
       * @returns Promise<ApiResponse<{ config: IUniConfig }>>
       */
      update: (() => {
        const method = "POST";
        const path = "/config/system/immigration-provider/{immigrationProvider}";
        const pathParamsSchema = z2.object({ immigrationProvider: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/config/system/immigration-provider/{immigrationProvider}";
            url = url.replace("{immigrationProvider}", encodeURIComponent(String(validated.immigrationProvider)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Branding: {
      /**
       * GET /system/get-branding-objects/{urlPrefix}
       * @pathParams {urlPrefix: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/system/get-branding-objects/{urlPrefix}";
        const pathParamsSchema = z2.object({ urlPrefix: z2.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/system/get-branding-objects/{urlPrefix}";
            url = url.replace("{urlPrefix}", encodeURIComponent(String(validated.urlPrefix)));
            return url;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Pathway: {
      Emails: {
        /**
         * GET /system/provider/{pathway}/get-email-objects/{uni}
         * @pathParams {pathway: string, uni: string}
         * @returns Promise<ApiResponse<unknown>>
         */
        get: (() => {
          const method = "GET";
          const path = "/system/provider/{pathway}/get-email-objects/{uni}";
          const pathParamsSchema = z2.object({ pathway: z2.string(), uni: z2.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/system/provider/{pathway}/get-email-objects/{uni}";
              url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z2.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    SSO: {
      /**
       * POST /system/sso/enable
       * @returns Promise<ApiResponse<unknown>>
       */
      enable: (() => {
        const method = "POST";
        const path = "/system/sso/enable";
        const buildUrl = () => "/system/sso/enable";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    Cache: {
      /**
       * PUT /sys-noauth/clear-redis-cache
       * @returns Promise<ApiResponse<APIResponse>>
       */
      clear: (() => {
        const method = "PUT";
        const path = "/sys-noauth/clear-redis-cache";
        const buildUrl = () => "/sys-noauth/clear-redis-cache";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    }
  },
  Automation: {
    /**
     * GET /automation/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<Automation[]>>
     */
    list: (() => {
      const method = "GET";
      const path = "/automation/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /automation/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<Automation>>
     */
    create: (() => {
      const method = "POST";
      const path = "/automation/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /automation/{uni}/{type}/{id}
     * @pathParams {uni: string, type: string, id: string}
     * @returns Promise<ApiResponse<Automation>>
     */
    get: (() => {
      const method = "GET";
      const path = "/automation/{uni}/{type}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), type: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}/{type}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{type}", encodeURIComponent(String(validated.type)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /automation/{uni}/{type}/{id}
     * @pathParams {uni: string, type: string, id: string}
     * @returns Promise<ApiResponse<Automation>>
     */
    update: (() => {
      const method = "PUT";
      const path = "/automation/{uni}/{type}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), type: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}/{type}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{type}", encodeURIComponent(String(validated.type)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /automation/{uni}/{type}/{id}
     * @pathParams {uni: string, type: string, id: string}
     * @returns Promise<ApiResponse<boolean>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/automation/{uni}/{type}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), type: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}/{type}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{type}", encodeURIComponent(String(validated.type)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /automation/{uni}/{type}/{id}/execute
     * @pathParams {uni: string, type: string, id: string}
     * @returns Promise<ApiResponse<ExecuteScheduledTaskResponse>>
     */
    execute: (() => {
      const method = "POST";
      const path = "/automation/{uni}/{type}/{id}/execute";
      const pathParamsSchema = z2.object({ uni: z2.string(), type: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}/{type}/{id}/execute";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{type}", encodeURIComponent(String(validated.type)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /automation/{uni}/{type}/applied-to
     * @pathParams {uni: string, type: string}
     * @returns Promise<ApiResponse<{ appliedTo: number }>>
     */
    appliedTo: (() => {
      const method = "POST";
      const path = "/automation/{uni}/{type}/applied-to";
      const pathParamsSchema = z2.object({ uni: z2.string(), type: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/automation/{uni}/{type}/applied-to";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{type}", encodeURIComponent(String(validated.type)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Agents: {
    /**
     * GET /agent/agents
     * @returns Promise<ApiResponse<IAgent[] | Partial<IAgent>[] | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agents";
      const buildUrl = () => "/agent/agents";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agents/search/{uni}/{query}
     * @pathParams {uni: string, query: string}
     * @returns Promise<ApiResponse<IAgent[] | ErrorResponse>>
     */
    search: (() => {
      const method = "GET";
      const path = "/agent/agents/search/{uni}/{query}";
      const pathParamsSchema = z2.object({ uni: z2.string(), query: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agents/search/{uni}/{query}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{query}", encodeURIComponent(String(validated.query ?? validated.QUERY ?? validated.query)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Agent: {
    /**
     * PUT /agent/agents
     * @returns Promise<ApiResponse<{ s_key: string } | ErrorResponse>>
     */
    create: (() => {
      const method = "PUT";
      const path = "/agent/agents";
      const buildUrl = () => "/agent/agents";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agents/{id}
     * @pathParams {id: string}
     * @queryParams z.object({ hasApplyAccessCheck: z.string().optional() })
     * @returns Promise<ApiResponse<IAgent | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agents/{id}";
      const pathParamsSchema = z2.object({ id: z2.string() });
      const queryParamsSchema = z2.object({ hasApplyAccessCheck: z2.string().optional() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agents/{id}";
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /agent/agents/{id}
     * @pathParams {id: string}
     * @returns Promise<ApiResponse<any | ErrorResponse>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/agent/agents/{id}";
      const pathParamsSchema = z2.object({ id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agents/{id}";
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  AgentAliases: {
    /**
     * GET /agent/agency-aliases/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<AliasesResponse | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agency-aliases/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agency-aliases/{uni}/search
     * @pathParams {uni: string}
     * @queryParams z.object({ searchField: z.string().optional(), searchQuery: z.string().optional() })
     * @returns Promise<ApiResponse<AliasesResponse | ErrorResponse>>
     */
    search: (() => {
      const method = "GET";
      const path = "/agent/agency-aliases/{uni}/search";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const queryParamsSchema = z2.object({ searchField: z2.string().optional(), searchQuery: z2.string().optional() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}/search";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z2.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        queryParamsSchema,
        buildUrl
      });
    })()
  },
  AgentAlias: {
    /**
     * POST /agent/agency-aliases/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<IAgentAliases | ErrorResponse>>
     */
    create: (() => {
      const method = "POST";
      const path = "/agent/agency-aliases/{uni}";
      const pathParamsSchema = z2.object({ uni: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agency-aliases/{uni}/{id}
     * @pathParams {uni: string, id: string}
     * @returns Promise<ApiResponse<IAgentAliases[] | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agency-aliases/{uni}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /agent/agency-aliases/{uni}/{id}
     * @pathParams {uni: string, id: string}
     * @body z.object({ id: z.string().optional(), aliases: z.array(z.string()), assignedAgent: z.string() })
     * @returns Promise<ApiResponse<IAgentAliases | ErrorResponse>>
     */
    update: (() => {
      const method = "PUT";
      const path = "/agent/agency-aliases/{uni}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
      const bodySchema = z2.object({ id: z2.string().optional(), aliases: z2.array(z2.string()), assignedAgent: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        try {
          const validatedBody = bodySchema.parse(args.body);
          return makeRequest(method, url, validatedBody, args.options);
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "request body");
            console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        bodySchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /agent/agency-aliases/{uni}/{id}
     * @pathParams {uni: string, id: string}
     * @returns Promise<ApiResponse<IAgentAliasesForDB | ErrorResponse>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/agent/agency-aliases/{uni}/{id}";
      const pathParamsSchema = z2.object({ uni: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-aliases/{uni}/{id}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  AgentOffices: {
    /**
     * GET /agent/agency-offices/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IEntityOffice[] | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agency-offices/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-offices/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  AgentOffice: {
    /**
     * POST /agent/agency-offices/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    create: (() => {
      const method = "POST";
      const path = "/agent/agency-offices/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-offices/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agency-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agency-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /agent/agency-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    update: (() => {
      const method = "PUT";
      const path = "/agent/agency-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /agent/agency-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<{ message: string } | ErrorResponse>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/agent/agency-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  AgentBranches: {
    /**
     * GET /agent/agency-branches/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IAgencyBranch[] | ErrorResponse>>
     */
    list: (() => {
      const method = "GET";
      const path = "/agent/agency-branches/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-branches/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  AgentBranch: {
    /**
     * POST /agent/agency-branches/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IAgencyBranch | ErrorResponse>>
     */
    create: (() => {
      const method = "POST";
      const path = "/agent/agency-branches/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-branches/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /agent/agency-branches/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IAgencyBranch | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/agency-branches/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-branches/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /agent/agency-branches/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IAgencyBranch | ErrorResponse>>
     */
    update: (() => {
      const method = "PUT";
      const path = "/agent/agency-branches/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-branches/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /agent/agency-branches/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<{ message: string } | ErrorResponse>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/agent/agency-branches/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/agency-branches/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  PartnerOffices: {
    /**
     * GET /agent/partner-offices/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IEntityOffice[] | ErrorResponse>>
     */
    list: (() => {
      const method = "GET";
      const path = "/agent/partner-offices/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/partner-offices/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  PartnerOffice: {
    /**
     * POST /agent/partner-offices/{entityId}
     * @pathParams {entityId: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    create: (() => {
      const method = "POST";
      const path = "/agent/partner-offices/{entityId}";
      const pathParamsSchema = z2.object({ entityId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/partner-offices/{entityId}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /agent/partner-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/agent/partner-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/partner-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /agent/partner-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<IEntityOffice | ErrorResponse>>
     */
    update: (() => {
      const method = "PUT";
      const path = "/agent/partner-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/partner-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * DELETE /agent/partner-offices/{entityId}/{id}
     * @pathParams {entityId: string, id: string}
     * @returns Promise<ApiResponse<{ message: string } | ErrorResponse>>
     */
    delete: (() => {
      const method = "DELETE";
      const path = "/agent/partner-offices/{entityId}/{id}";
      const pathParamsSchema = z2.object({ entityId: z2.string(), id: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/agent/partner-offices/{entityId}/{id}";
          url = url.replace("{entityId}", encodeURIComponent(String(validated.entityId ?? validated.ENTITYID ?? validated.entityId)));
          url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  StudentPortal: {
    /**
     * GET /students/{uni}/{studentNo}/active-offers
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<StudentPortalActiveOffersResponse>>
     */
    activeOffers: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/active-offers";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/active-offers";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/active-offer
     * @pathParams {uni: string, studentNo: string}
     * @body z.object({ intakeId: z.string(), offerId: z.string() })
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    setActiveOffer: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/active-offer";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
      const bodySchema = z2.object({ intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/active-offer";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        try {
          const validatedBody = bodySchema.parse(args.body);
          return makeRequest(method, url, validatedBody, args.options);
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "request body");
            console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        bodySchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<GetStudentResponse>>
     */
    getCas: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateStudent: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}/docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentDocsResponse>>
     */
    docs: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFinDocsResponse>>
     */
    finDocs: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/upload
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<UploadPresignedUrlResponse>>
     */
    upload: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/upload";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/upload";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/finance
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateFinance: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateVisaPrep: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateVisaStatus: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
      const pathParamsSchema = z2.object({ uni: z2.string(), studentNo: z2.string(), intakeId: z2.string(), offerId: z2.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z2.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  }
};
export {
  ApiClient,
  ApiValidationError,
  ApplyConfigSchema,
  Schemas,
  configureFetch
};
